{
    "Anonymous.NotAvailable.Heading": "Non disponible",
    "Anonymous.NotAvailable.Body": "Ce webinaire n'est pas disponible pour les spectateurs anonymes.",

    "Account.ApiErrorCode.Exception": "Quelque chose s'est mal passé",
    "Account.ApiErrorCode.NotFoundException": "Compte non trouvé",
    "Account.ApiErrorCode.AccessDeniedException": "E-mail ou mot de passe invalide",
    "Account.ApiErrorCode.AccountNotVerifiedException": "Compte non vérifié",
    "Account.ApiErrorCode.ConflictException": "Le compte existe déjà",
    "Account.ApiErrorCode.LockedOutException": "Le compte est bloqué. Réinitialisez votre mot de passe pour retrouver l’accès.",
    "Account.ApiErrorCode.ThrottledException": "Trop de tentatives depuis votre réseau. Réessayez plus tard.",
    "Account.ApiErrorCode.AccountLinkCodeInvalidException": "Code invalide",
    "Account.ApiErrorCode.AccountLinkCodeAlreadyUsedException": "Le code a été utilisé",
    "Account.ApiErrorCode.AccountLinkCodeExpiredException": "Le code a expiré",
    "Account.ApiErrorCode.ImageFormatException": "Format d'image invalide",
    "Account.Bar.Text": "Gestion du compte de",
    "Account.Button": "Mon compte",
    "Account.Button.ForgotPassword": "Mot de passe oublié",
    "Account.Button.ChangePassword": "Modifier le mot de passe",
    "Account.Button.ResetPassword": "Réinitialiser le mot de passe",
    "Account.Button.ShowPassword": "Afficher le mot de passe",
    "Account.Button.HidePassword": "Masquer le mot de passe",
    "Account.Button.Login": "Se connecter",
    "Account.Button.Register": "S'inscrire",
    "Account.Button.Next": "Suivant",
    "Account.Button.Back": "Retour",
    "Account.Button.Cancel": "Annuler",
    "Account.Images.Button.DeleteBannerImage.AriaLabel": "Supprimer l'image de bannière",
    "Account.Images.Button.DeleteProfileImage.AriaLabel": "Supprimer l'image de profil",
    "Account.Images.Button.UploadBannerImage.AriaLabel": "Télécharger l'image de bannière",
    "Account.Images.Button.UploadProfileImage.AriaLabel": "Télécharger l'image de profil",
    "Account.Images.Label": "Image de profil et de bannière de webinaire par défaut",

    "AccountInvite.Button.Reject": "Refuser l'invitation",
    "AccountInvite.Info": "Vous avez été invité à rejoindre cette plateforme de webinaire. Veuillez saisir vos informations pour créer un compte, ou refuser l'invitation.",
    "AccountInvite.PageHeading": "Vous êtes invité",
    "AccountInvite.AccountLinkCodeAlreadyUsedException": "Vous avez déjà un compte chez nous",
    "AccountInvite.AccountLinkCodeAlreadyUsedException.Body": "Un compte a déjà été créé avec ce lien d’invitation. Si vous avez oublié votre mot de passe, vous pouvez utiliser la fonction ‘Mot de passe oublié’ lors de la connexion.",

    "AccountInvites.PageHeading": "Inviter des participants à votre environnement",

    "Account.Management.Button.Invite": "Inviter",
    "Account.Management.Button.RemoveAccount": "Supprimer {{account}}",
    "Account.Management.Heading.InvitedAccounts": "Membres invités",
    "Account.Management.InfoText": "Ici, vous pouvez inviter d'autres personnes à gérer vos webinaires. Elles pourront : <ul><li>Créer et modifier des webinaires</li><li>Voir les statistiques</li><li>Modérer des webinaires</li><li>Diffuser des webinaires</li></ul><br>Pour inviter quelqu'un, entrez l'adresse e-mail de la personne que vous souhaitez inviter. Un e-mail sera alors envoyé à la personne en question.",
    "Account.Management.PageHeading": "Gérer le compte",
    "Account.Management.InviteStatus.Accepted": "accepté",
    "Account.Management.InviteStatus.Pending": "en attente",
    "Account.Management.InviteStatus.Rejected": "refusé",
    "Account.Label.FirstName": "Prénom",
    "Account.Label.LastName": "Nom de famille",
    "Account.Label.Nickname": "Pseudo",
    "Account.Label.CompanyName": "Nom de l'entreprise",
    "Account.Label.Country": "Pays",
    "Account.Label.Email": "E-mail",
    "Account.Label.Password": "Mot de passe",
    "Account.Label.ForgotPasswordCode": "Code de mot de passe oublié",
    "Account.Label.CurrentPassword": "Mot de passe actuel",
    "Account.Label.NewPassword": "Nouveau mot de passe",
    "Account.Label.TermsAndConditions1": "J'accepte les ",
    "Account.Label.TermsAndConditions2": "termes et conditions",
    "Account.Link.TermsAndConditions": "https://www.onlinewebinar.com/company/terms-of-service",
    "Account.Menu.Logout": "Se déconnecter",
    "Account.Menu.ManageAccount": "Gérer le compte",
    "Account.Menu.NotOnMainAccount": "Les détails du compte ne sont pas disponibles lors de la gestion d'un autre compte",
    "Account.Menu.Password": "Mon mot de passe",
    "Account.Menu.Profile": "Mon profil",
    "Account.Menu.SwitchAccount": "Changer de compte",
    "Account.Menu.Welcome": "Bon retour parmi nous",
    "Account.Message.SendingEmail": "Envoi de l'e-mail à <strong>{{email}}</strong>",
    "Account.Message.ErrorSendingEmail": "Une erreur s'est produite lors de l'envoi de l'e-mail à <strong>{{email}}</strong>. Veuillez réessayer plus tard.",
    "Account.Message.EmailSent": "Un e-mail a été envoyé à <strong>{{email}}</strong> avec le code pour réinitialiser votre mot de passe.",
    "Account.Message.PasswordChanged": "Votre mot de passe a été modifié.",
    "Account.Password.Changed.Message": "Votre mot de passe a été modifié avec succès.",
    "Account.Password.PageHeading": "Mon mot de passe",
    "Account.Profile.Changed.Message": "Profil utilisateur mis à jour avec succès.",
    "Account.Profile.PageHeading": "Mon profil",
    "Account.Profile.NotAvailable": "Profil non disponible",
    "Account.Profile.NotAvailable.Body": "Votre profil de compte n'est pas disponible pour le moment. Cela est dû au fait que vous gérez actuellement un autre compte. Revenez à votre propre compte pour consulter et modifier vos informations de profil.",
    "Account.Tab.ApiKeys": "Clés API",
    "Account.Tab.ManageAccount": "Gérer le compte",
    "Account.Tab.Password": "Mot de passe",
    "Account.Tab.Profile": "Profil",

    "Account.ApiKeys.PageHeading": "Clés API",
    "Account.ApiKeys.Description": "Les clés API permettent un accès programmatique à votre compte. Gardez-les secrètes — toute personne possédant une clé peut agir en votre nom.",
    "Account.ApiKeys.Label.Name": "Nom de la clé",
    "Account.ApiKeys.Button.Create": "Créer une clé API",
    "Account.ApiKeys.Button.Dismiss": "Fermer",
    "Account.ApiKeys.Button.Revoke": "Révoquer {{name}}",
    "Account.ApiKeys.Heading.ActiveKeys": "Clés API actives",
    "Account.ApiKeys.CreatedAt": "Créée le {{date}}",
    "Account.ApiKeys.Created.Title": "Clé API créée",
    "Account.ApiKeys.Created.Warning": "Copiez cette clé maintenant — elle ne sera plus affichée.",
    "Account.ApiKeys.Validation.NameRequired": "Le nom de la clé est requis",

    "Account.Validation.EmailRequired": "L'adresse e-mail est requise",
    "Account.Validation.PasswordRequired": "Le mot de passe est requis",
    "Account.Verification.Failed.Title": "Vérification échouée",
    "Account.Verification.Pending.Title": "Vérification en cours",
    "Account.Verification.Required.Title": "Vérification du compte requise",
    "Account.Verification.Required.Body": "Pour continuer, veuillez vérifier votre compte en cliquant sur le lien dans l'e-mail que nous vous avons envoyé. Pour recevoir un nouvel e-mail de vérification, cliquez sur le bouton ci-dessous.",
    "Account.Verification.Required.Button": "Renvoyer l'e-mail de vérification",
    "Account.Verification.Required.Error": "Une erreur s'est produite lors de l'envoi de l'e-mail de vérification. Veuillez réessayer ultérieurement.",
    "Account.Verification.Required.Success": "Un nouvel e-mail de vérification a été envoyé à votre adresse e-mail. Si vous ne voyez pas l'e-mail dans votre boîte de réception d'ici quelques minutes, veuillez vérifier votre dossier de spams.",
    "Account.Verification.Succeeded.Heading": "Vérifié",
    "Account.Verification.Succeeded.Subheading": "Merci !",
    "Account.Verification.Succeeded.Text": "Votre compte est maintenant vérifié et vous pouvez utiliser toutes les fonctionnalités de l'application.",
    "Account.DeleteAccount.Button": "Supprimer le compte",
    "Account.DeleteAccount.Confirm.Body": "Cela supprimera définitivement votre compte et toutes les données associées. Vous serez déconnecté immédiatement. Cette action est irréversible.",
    "Account.DeleteAccount.Confirm.Button": "Oui, supprimer le compte",
    "Account.DeleteAccount.Confirm.Title": "Supprimer votre compte ?",
    "Account.DeleteAccount.PageHeading": "Supprimer le compte",
    "Account.DeleteAccount.Warning": "Supprime définitivement votre compte, vos identifiants de connexion et tous les liens de gestion de compte. L'historique de participation aux webinaires est conservé. Cette action est irréversible.",

    "AccountManagerInvite.Button.AcceptInvite": "Accepter l'invitation",
    "AccountManagerInvite.Button.RejectInvite": "Refuser l'invitation",
    "AccountManagerInvite.InviteBody": "Vous avez été invité à gérer les webinaires pour {{name}}. Tout d'abord, veuillez vérifier votre compte, puis vous pourrez nous faire savoir si vous acceptez ou refusez l'invitation.",
    "AccountManagerInvite.InviteBodyVerified": "Vous avez été invité à gérer les webinaires pour {{name}}. Veuillez nous faire savoir si vous acceptez ou refusez l'invitation.",
    "AccountManagerInvite.InviteBody.CombineNameAndCompanyName": "{{name}} de {{companyName}}",
    "AccountManagerInvite.InviteUsed": "Le lien d'invitation a déjà été utilisé.",
    "AccountManagerInvite.Invalid": "Le lien d'invitation n'est pas valide.",
    "AccountManagerInvite.InviteExpired": "Nos excuses, votre invitation a expiré. Veuillez contacter {{name}} pour demander un nouveau lien.",
    "AccountManagerInvite.PageHeading": "Vous avez été invité par {{account}}",

    "AccountSwitch.Button.SwitchAccount": "Passer au compte {{account}}",
    "AccountSwitch.ManagedAccounts.Heading": "Comptes gérés :",
    "AccountSwitch.PageHeading": "Changer de compte",
    "AccountSwitch.PersonalAccount.Heading": "Compte personnel :",

    "Beta.Heading": "Fonctionnalités bêta",
    "Beta.Text.Icon": "Attention : fonctionnalité bêta",
    "Beta.Text.LiveTranscribe": "La transcription en direct est encore en version bêta, à utiliser avec précaution.",

    "Button.Back": "Retour à la page précédente",
    "Button.BackToContent": "Retour au contenu du webinaire",
    "Button.BackToInsights": "Retour aux statistiques du webinaire",
    "Button.BackToManageEnv": "Retour à la gestion de l'environnement",
    "Button.BackToOrganized": "Retour aux webinaires à venir",
    "Button.BackToOrganizedEnded": "Retour aux webinaires terminés",
    "Button.BackToOverview": "Retour à l'aperçu",
    "Button.BackToPoll": "Retour au sondage",

    "Broadcaster.AudioAndVideoSelect.AudioSelect.label": "Sélectionnez un périphérique audio",
    "Broadcaster.AudioAndVideoSelect.Heading": "Sélectionnez un périphérique audio et vidéo",
    "Broadcaster.AudioAndVideoSelect.IngestAvailability": "L'URL d'ingestion est disponible uniquement pendant la plage horaire allouée, du <strong>{{timeslotstart}}</strong> au <strong>{{timeslotend}}</strong>. En dehors de cette plage horaire, la connexion échouera.",
    "Broadcaster.AudioAndVideoSelect.Quality.label": "Qualité vidéo",
    "Broadcaster.AudioAndVideoSelect.Quality.High": "Élevée (1280×720, 4 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.Medium": "Moyenne (1280×720, 2 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.Low": "Basse (854×480, 1 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.HighWarning": "La <strong>qualité élevée</strong> nécessite un ordinateur rapide et une connexion internet stable à haut débit. Choisissez Moyenne ou Basse en cas de saccades.",
    "Broadcaster.AudioAndVideoSelect.RTMP.Link": "L'URL RTMP :",
    "Broadcaster.AudioAndVideoSelect.RTMP.BaseLink": "L'URL RTMP BASE :",
    "Broadcaster.AudioAndVideoSelect.RTMP.StreamKey": "La clé de flux RTMP :",
    "Broadcaster.AudioAndVideoSelect.SRT.Link": "L'URL SRT :",
    "Broadcaster.AudioAndVideoSelect.SRT.StreamId": "L'identifiant du flux SRT :",
    "Broadcaster.AudioAndVideoSelect.UseClassicConnection.Label": "Utiliser la connexion classique (WebRTC)",
    "Broadcaster.AudioAndVideoSelect.UseClassicConnection.InfoText": "Par défaut, nous diffusons via Media over QUIC. Choisissez la connexion classique si vous rencontrez des problèmes avec votre diffusion ; votre choix est mémorisé dans ce navigateur.",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.label": "Sélectionnez un périphérique vidéo",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.RTMP": "Périphérique RTMP",
    "Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen": "Arrêtez d'abord votre encodeur externe",
    "Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen.Body": "Vous passez d'un encodeur externe à votre navigateur. Si l'encodeur diffuse encore, les deux se disputent le même canal : vos spectateurs verront l'image disparaître et revenir sans cesse jusqu'à ce que l'un des deux s'arrête. Arrêtez le flux dans votre encodeur avant de continuer.",
    "Broadcaster.AudioAndVideoSelect.FirefoxWebcamUnavailable": "La diffusion avec votre webcam est temporairement indisponible dans Firefox. Nous travaillons sur une solution pour que vous puissiez de nouveau utiliser Firefox à l'avenir. En attendant, veuillez ouvrir cette page dans un autre navigateur, comme Chrome, Edge ou Safari, ou diffuser avec un encodeur externe via RTMP ou SRT.",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.SRT": "Périphérique SRT",

    "Broadcaster.AccessDenied.Title": "Impossible de diffuser le webinaire",
    "Broadcaster.AccessDenied": "Vous n'êtes pas autorisé à diffuser ce webinaire. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'équipe d'assistance d'OnlineWebinar.com.",
    "Broadcaster.Error.Title": "Une erreur s'est produite",
    "Broadcaster.Error": "Une erreur s'est produite lors de la diffusion du webinaire. Veuillez réessayer ultérieurement ou contacter l'équipe d'assistance d'OnlineWebinar.com.",
    "Broadcaster.NoBooking.Title": "Plage horaire non disponible",
    "Broadcaster.NoBooking": "Vous ne pouvez pas démarrer le webinaire car il n'y a pas de réservation pour ce webinaire. Veuillez vérifier les détails de la réservation du webinaire ou contacter l'équipe d'assistance d'OnlineWebinar.com pour obtenir de l'aide.",
    "Broadcaster.NoVideoPreview": "Aperçu non disponible",
    "Broadcaster.NotActivePresenter": "Un autre présentateur est actuellement en diffusion. Souhaitez-vous prendre la relève ?",
    "Broadcaster.UnsupportedBrowser.Title": "Navigateur non pris en charge",
    "Broadcaster.UnsupportedBrowser": "Votre navigateur n'est pas compatible avec la diffusion de webinaires. Veuillez utiliser un navigateur moderne tel que Google Chrome, Mozilla Firefox, Microsoft Edge ou Safari.",
    "Broadcaster.AudioAndVideoSelection.NoDevicesError": "Nous n'avons trouvé aucun périphérique audio et/ou vidéo. Veuillez vous assurer que le site Web dispose des autorisations pour y accéder. <br> Ou vérifiez s'ils sont utilisés, par exemple lorsque le diffuseur est déjà ouvert dans un autre onglet.",
    "Broadcaster.Button.ClaimActivePresenter": "Prendre la relève en tant que présentateur",
    "Broadcaster.Button.DesktopShare": "Partage d'écran",
    "Broadcaster.Button.End": "Terminer la diffusion",
    "Broadcaster.Button.Pause": "Pause",
    "Broadcaster.Button.Resume": "Reprendre !",
    "Broadcaster.Button.Start": "Passer en direct !",
    "Broadcaster.Button.ExtendDuration": "Prolonger la durée de {{minutes}} minutes",
    "Broadcaster.Button.NextSlideToggle.Max": "Maximiser l'aperçu de la diapositive",
    "Broadcaster.Button.NextSlideToggle.Min": "Minimiser l'aperçu de la diapositive",
    "Broadcaster.Button.SwitchFullSize.ToSlides": "Passer en diapositives pleine taille",
    "Broadcaster.Button.SwitchFullSize.ToVideo": "Passer en vidéo pleine taille",

    "Broadcaster.Dialog.ConnectionIssue.Button.Close": "Fermer et retourner à la diffusion",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.Text": "Aucune vidéo ne provient plus de votre encodeur, ou la connexion au serveur a été perdue. <strong>Cela ne met pas le webinaire en pause :</strong> les spectateurs verront et entendront de nouveau ce que votre encodeur envoie dès qu'il se reconnectera.<br>Veuillez vérifier votre encodeur et votre connexion Internet.",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.WaitingForMedia": "La connexion au serveur fonctionne, mais aucune vidéo ne provient de votre encodeur. Vérifiez que votre encodeur diffuse toujours.",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.TextResume": "Dès que votre encodeur diffuse de nouveau, vous pouvez fermer cette fenêtre et continuer.",
    "Broadcaster.Dialog.ConnectionIssue.Reconnecting": "Tentative de reconnexion au serveur.",
    "Broadcaster.Dialog.ConnectionIssue.WaitingForMedia": "La connexion au serveur fonctionne. Nous attendons le retour de votre vidéo et de votre son ; vous pourrez reprendre dès qu’ils seront revenus.",
    "Broadcaster.Dialog.ConnectionIssue.SuggestRefresh": "Actualiser la page pour recharger la diffusion.",
    "Broadcaster.Dialog.ConnectionIssue.Text": "Nous avons perdu la connexion au serveur en raison d'un problème avec votre connexion Internet. <strong>Le webinaire a été mis en pause.</strong><br>Veuillez vérifier votre connexion et/ou fermer les autres onglets de votre navigateur.",
    "Broadcaster.Dialog.ConnectionIssue.TextResume": "Si la connexion revient, vous pouvez cliquer sur le bouton Reprendre ci-dessous pour continuer la diffusion.",
    "Broadcaster.Dialog.ConnectionIssue.Title": "Connexion perdue",
    "Broadcaster.Dialog.EncoderPause.Title": "Mettre en pause un encodeur externe",
    "Broadcaster.Dialog.EncoderPause.Text": "Cette diffusion provient de votre propre encodeur : nous ne pouvons pas mettre la vidéo entrante en pause. Vos spectateurs continuent de recevoir ce que votre encodeur envoie, quel que soit l'état de ce webinaire. Coupez le son et l'image dans votre encodeur si vous ne voulez pas être vu ni entendu.",
    "Broadcaster.Dialog.MoqFallback.Title": "Passage à la connexion classique",
    "Broadcaster.Dialog.MoqFallback.Text": "Media over QUIC n'a pas pu se connecter. Nous nous connectons maintenant via la connexion classique (WebRTC). Si vous étiez déjà en direct, reprenez le webinaire dès que votre image est revenue.",
    "Broadcaster.Moq.SlowConnect.Text": "La connexion via Media over QUIC prend plus de temps que prévu…",
    "Broadcaster.Moq.SlowConnect.Button": "Passer maintenant à la connexion classique (WebRTC)",
    "Broadcaster.Dialog.EndWebinar.Button.Confirm": "Oui, terminer la diffusion",
    "Broadcaster.Dialog.EndWebinar.Text": "Êtes-vous sûr de vouloir terminer cette diffusion ?",
    "Broadcaster.Dialog.EndWebinar.Title": "Terminer la diffusion",
    "Broadcaster.Dialog.TooEarly.Title": "Oups, vous êtes un peu en avance !",
    "Broadcaster.Dialog.TooEarly.Text": "Nous avons remarqué que vous souhaitez commencer votre webinaire un peu plus tôt que l'heure prévue. Êtes-vous sûr de vouloir le faire ?",
    "Broadcaster.Dialog.TooEarly.CountdownText": "Compte à rebours avant l'heure de début prévue :",
    "Broadcaster.Dialog.TooEarly.OnlineViewersTitle": "Nombre de spectateurs déjà en ligne :",
    "Broadcaster.Dialog.TooEarly.OnlineViewersText": "en ligne",

    "Broadcaster.Message.Ended": "Ce webinaire s'est terminé <span>le</span> {{date}} <span>à</span> {{time}}",
    "Broadcaster.Poll.Button.Start": "Démarrer le sondage",
    "Broadcaster.Poll.Button.Close": "Clôturer le sondage",
    "Broadcaster.Poll.Button.HideResults": "Masquer les résultats",
    "Broadcaster.Poll.NoPublicResults": "Les résultats de ce sondage ne sont pas visibles publiquement.",
    "Broadcaster.Poll.WeightingApplied": "Facteur de pondération appliqué",
    "Broadcaster.RemainingTimePanel.Ending": "Le webinaire se terminera dans",
    "Broadcaster.RemainingTimePanel.ExtensionFailed": "L'heure de fin du webinaire n'a pas pu être prolongée",
    "Broadcaster.RemainingTimePanel.ExtensionNotAvailable": "L'heure de fin du webinaire ne peut plus être prolongée",
    "Broadcaster.RemainingTimePanel.ExtensionSuccess": "L'heure de fin du webinaire a été prolongée avec succès",

    "Broadcaster.Status.Broadcasting": "Diffusion en cours",
    "Broadcaster.Status.GoLiveIn": "Passez en direct en",
    "Broadcaster.Status.GoLiveNow": "Passez en direct maintenant",
    "Broadcaster.Status.Ended": "Terminé",
    "Broadcaster.Status.Camera": "La caméra est sélectionnée",
    "Broadcaster.Status.Camera.Issue": "Aucune caméra appropriée sélectionnée",
    "Broadcaster.Status.Heading": "Statut",
    "Broadcaster.Status.Mic": "Le microphone est sélectionné",
    "Broadcaster.Status.Mic.Issue": "Aucun microphone sélectionné",
    "Broadcaster.Status.PossibleSolution": "Solution possible :",
    "Broadcaster.Status.Recorder.Issue": "Votre webinaire n'est pas enregistré",
    "Broadcaster.Status.Recorder": "Votre webinaire est enregistré",
    "Broadcaster.Status.Encoder": "Les réglages de votre encodeur sont corrects",
    "Broadcaster.Status.Encoder.Issue.Audio": "Votre encodeur envoie du son surround",
    "Broadcaster.Status.Encoder.Issue.Level": "Votre encodeur utilise un réglage vidéo que certains appareils refusent",
    "Broadcaster.Status.Encoder.Issue.Unknown": "Nous n'avons pas encore pu vérifier votre encodeur",
    "Broadcaster.Status.Solution.Encoder.Audio": "Réglez votre encodeur sur stéréo (2 canaux) et reconnectez-vous. Tant que ce n'est pas fait, les spectateurs sous Firefox n'entendent rien et vous ne pouvez pas passer en direct.",
    "Broadcaster.Status.Solution.Encoder.Level": "Réglez le niveau H.264 de votre encodeur sur 4.2, ou sur automatique, et reconnectez-vous. Tant que ce n'est pas fait, certains iPhone, iPad et téléviseurs refusent le flux et vous ne pouvez pas passer en direct.",
    "Broadcaster.Status.Encoder.Issue.AudioAndLevel": "Deux réglages de votre encodeur doivent être modifiés",
    "Broadcaster.Status.Solution.Encoder.AudioAndLevel": "Réglez votre encodeur sur stéréo (2 canaux) et le niveau H.264 sur 4.2, ou sur automatique. Reconnectez-vous ensuite. En attendant, les spectateurs sous Firefox n'entendent rien, certains iPhone, iPad et téléviseurs refusent le flux, et vous ne pouvez pas passer en direct.",
    "Broadcaster.Status.Solution.Encoder.Unknown": "Si vous venez de connecter votre encodeur, patientez quelques secondes. Si ce message persiste, vérifiez que votre encodeur diffuse.",
    "Broadcaster.Status.Server": "Connecté au serveur",
    "Broadcaster.Status.Server.Issue": "Pas de connexion au serveur",
    "Broadcaster.Status.Solution.Initializing": "La connexion est en cours d'initialisation, veuillez patienter",
    "Broadcaster.Status.Solution.Refresh": "Actualisez votre navigateur",
    "Broadcaster.Status.Solution.WaitForTimeslot": "Attendez que votre créneau horaire soit disponible",
    "Broadcaster.Status.Solution.Button.Reconnect": "Cliquez ici pour vous reconnecter",
    "Broadcaster.Status.Troubleshoot.Button": "Dépannage",
    "Broadcaster.Status.Troubleshoot.Text": "Si les problèmes persistent, cliquez sur le bouton ci-dessous pour accéder à une page de dépannage avec les problèmes et solutions les plus courants :",
    "Broadcaster.Status.VideoServer": "Connecté au serveur vidéo",
    "Broadcaster.Status.VideoServer.Issue": "Pas de connexion au serveur vidéo",
    "Broadcaster.Status.VideoServer.Optimal": "Connexion optimale au serveur vidéo",
    "Broadcaster.Status.VideoServer.Score": "Score de connexion actuel :",
    "Broadcaster.Status.VideoServer.Score.Audio": "Le score audio est de <strong>{{audioScore}}</strong> sur <strong>10</strong>",
    "Broadcaster.Status.VideoServer.Score.Video": "Le score vidéo est de <strong>{{videoScore}}</strong> sur <strong>10</strong>",
    "Broadcaster.Status.VideoServer.Score.Text": "Votre connexion Internet ou votre ordinateur peut ne pas être assez rapide pour diffuser un webinaire. Si vous utilisez une connexion sans fil, essayez de passer à une connexion filaire.",
    "Broadcaster.Status.VideoServer.Unstable": "La connexion avec le serveur vidéo est instable",
    "Broadcaster.Status.ServerActions.Issue": "Le serveur rencontre des problèmes pour traiter certaines de vos actions",

    "Chat.Button.ChatPaused.FollowChat": "Voir dernier message",
    "Chat.Button.ChatPaused.Paused": "Discussion interrompue en raison du défilement",
    "Chat.ChannelName.All": "Tous",
    "Chat.ChannelName.Public": "Public",
    "Chat.ChannelName.Moderator": "Modérateurs",
    "Chat.ChannelName.Presenter": "Présentateur",
    "Chat.ChannelName.Speakers": "Intervenants",
    "Chat.ChannelName.Unknown": "Inconnu",
    "Chat.Channel.Button.Close": "Fermer le canal de discussion privé avec {{channelName}}",
    "Chat.Channel.Button.CloseAndMarkUnread": "Fermer le canal de discussion privé avec {{channelName}}, et marquer les messages comme non lus",
    "Chat.Message.Button.CancelForward": "Annuler le transfert du message",
    "Chat.Message.Deleted": "Ce message a été supprimé",
    "Chat.Message.ForwardedFrom": "Transféré de ",
    "Chat.Message.ReplyingTo": "Répondre à ",
    "Chat.MessageInput.CharactersRemaining": "{{characterAmount}} caractères restants",
    "Chat.OnDemand.InfoText": "Vos messages seront transférés. Nous vous répondrons sous 48 heures.",
    "Chat.Option.Delete": "Supprimer le message",
    "Chat.Option.ForwardToPresenter": "Transférer vers la discussion du présentateur",
    "Chat.Option.ForwardToModerator": "Transférer vers la discussion du modérateur",
    "Chat.Option.ForwardToPublic": "Transférer vers la discussion publique",
    "Chat.Option.OriginalForwardToModerator": "Transférer le message d'origine vers le chat des modérateurs",
    "Chat.Option.OriginalForwardToPresenter": "Transférer le message d'origine vers le chat du présentateur",
    "Chat.Option.OriginalForwardToPublic": "Transférer le message d'origine vers le chat public",
    "Chat.Option.ReplyPrivately": "Répondre en privé",
    "Chat.OnDemandChat.Nickname": "Message système",
    "Chat.OnDemandChat.Message": "Vos messages de discussion ont été transmis au présentateur.",

    "ChatSettings.OnDemandChat.Label.Email": "Transférer à l'adresse e-mail",
    "ChatSettings.OnDemandChat.Switch.Label": "Activer le chat à la demande",
    "ChatSettings.PageHeading": "Paramètres de chat",

    "Chat.Standard.Header": "Messages standard",
    "Chat.Standard.Message1": "",
    "Chat.Standard.Message2": "",
    "Chat.Standard.Message3": "",
    "Chat.Standard.Message4": "",
    "Chat.Standard.Message5": "",
    "Chat.Standard.Message6": "",
    "Chat.Standard.Message7": "",
    "Chat.Standard.Message8": "",
    "Chat.Standard.Message9": "",
    "Chat.Standard.NoMessages": "Aucun message standard n'a encore été défini.",

    "CompositePageHeader.Label.Date": "date :",
    "CompositePageHeader.Label.Event": "événement :",

    "ContactList.Button.Export": "Exporter la liste",
    "ContactList.Table.Header.Date": "Date",
    "ContactList.Table.Header.FirstOnline": "Première connexion",
    "ContactList.Table.Header.TimeOnline": "Temps en ligne",
    "ContactList.Table.Header.PercentageOnline": "%",

    "Content.Attachments.Button.Delete": "Supprimer la pièce jointe {{file}}",
    "Content.Attachments.Button.Edit": "Modifier la pièce jointe {{file}}",
    "Content.Attachments.Dialog.Heading": "Modifier la pièce jointe",
    "Content.Attachments.Dialog.Label.AttachmentTitle": "Nom de la pièce jointe",
    "Content.Attachments.Dialog.Label.AttachmentVisibility": "Visibilité de la pièce jointe",
    "Content.Attachments.DragDrop.AcceptedFileTypes": "PDF",
    "Content.Attachments.Heading.MultipleAttachments": "{{amount}} pièces jointes",
    "Content.Attachments.Heading.OneAttachment": "1 pièce jointe",
    "Content.Attachments.PageHeading": "Pièces jointes",
    "Content.Attachments.Progress.Label": "Téléchargement du document :",
    "Content.Attachments.Table.Header.Visibility": "Visibilité",
    "Content.Attachments.Table.Header.Title": "Titre",
    "Content.Attachments.Table.Header.Type": "Type",
    "Content.Attachments.Type.File": "Fichier",
    "Content.Attachments.Visibility.Authenticated": "Authentifié",
    "Content.Attachments.Visibility.Private": "Privé",
    "Content.Attachments.Visibility.Public": "Public",

    "Content.Chapters.Button.AddChapter": "Ajouter un chapitre",
    "Content.Chapters.Button.DeleteChapter": "Supprimer le chapitre {{chapter}}",
    "Content.Chapters.ChapterTitleHeader": "Titre du chapitre",
    "Content.Chapters.ConfirmDelete.Title": "Supprimer le chapitre",
    "Content.Chapters.ConfirmDelete.Msg": "Êtes-vous sûr de vouloir supprimer le chapitre <strong>{{chapter}}</strong> ?",
    "Content.Chapters.PageHeading": "Chapitres",
    "Content.Chapters.SlideNumberHeader": "Commence avec la diapositive",
    "Content.Chapters.ReadOnly": "Ce webinaire a déjà été diffusé. Vous pouvez modifier les chapitres dans l'éditeur à la demande.",

    "Content.Overview.Button.Edit": "Modifier",
    "Content.Overview.Button.Share": "Partager",
    "Content.Overview.Button.Broadcast": "Diffuser",
    "Content.Overview.Button.Publish": "Publier",
    "Content.Overview.Button.Unpublish": "Annuler la publication",
    "Content.Overview.Exam.Active": "Examen activée",
    "Content.Overview.Exam.Inactive": "Examen désactivée",
    "Content.Overview.Exam.NotValid": "Examen non valide",
    "Content.Overview.Images.Info": "L'image de profil doit avoir une taille minimale de 120 x 120 pixels. L'image de bannière doit avoir une taille minimale de 896 x 224 pixels. Vous pouvez utiliser des images avec des rapports d'aspect différents, elles seront recadrées autour du centre.",
    "Content.Overview.Images.Label": "Image de profil et de bannière du webinaire",
    "Content.Overview.Security.Active": "Sécurité active",
    "Content.Overview.Security.Inactive": "Sécurité inactive",
    "Content.Overview.Survey.Active": "Enquête activée",
    "Content.Overview.Survey.Inactive": "Enquête désactivée",
    "Content.Overview.Survey.NotValid": "Enquête non valide",

    "Content.Poll.AddPoll": "Ajouter un sondage",
    "Content.Poll.AnswerHeader": "Réponses",
    "Content.Poll.PointsHeader": "Points (facultatif)",
    "Content.Poll.Button.DeletePollAnswer": "Supprimer la réponse du sondage",
    "Content.Poll.Button.DeletePoll": "Supprimer le sondage",
    "Content.Poll.Button.DeletePollAriaLabel": "Supprimer le sondage {{poll}}",
    "Content.Poll.ConfirmDelete.Title": "Supprimer le sondage",
    "Content.Poll.ConfirmDelete.Msg": "Êtes-vous sûr de vouloir supprimer <strong>{{poll}}</strong> ?",
    "Content.Poll.Link.WeightinFactor": "Liste des facteurs de pondération",
    "Content.Poll.Option.ApplyWeighting": "Appliquer un facteur de pondération à ce sondage",
    "Content.Poll.Option.PublicResults": "Afficher les résultats du sondage aux spectateurs",
    "Content.Poll.Option.ShowPercentagesOnly": "Afficher uniquement les pourcentages dans les résultats du sondage",
    "Content.Poll.Option.ShowPercentagesOnly.DisabledReason": "S'applique uniquement lorsque les résultats du sondage sont affichés aux spectateurs",
    "Content.Poll.PageHeading": "Sondages",
    "Content.Poll.PollItemHeader": "Que souhaitez-vous demander à votre public ?",
    "Content.Poll.QuestionLabel": "Votre question",
    "Content.Poll.OptionLabel": "Réponse {{index}}{{char}}",
    "Content.Poll.OptionPlaceholder": "Réponse",
    "Content.Poll.PointsLabel": "Points pour la réponse {{index}}{{char}} (facultatif)",
    "Content.Poll.PointsPlaceholder": "Points",
    "Content.Poll.UpdateOnlyWarning": "Ce webinaire a déjà été diffusé. Seuls le facteur de pondération et les points du sondage peuvent être mis à jour.",

    "Content.PollWeighting.Button.ClearList": "Vider la liste",
    "Content.PollWeighting.DragDrop.AcceptedFileTypes": ".xls, .xlsx et .csv",
    "Content.PollWeighting.Input.DefaultWeight": "Facteur de pondération par défaut",
    "Content.PollWeighting.Heading.DefaultWeight": "Facteur de pondération par défaut",
    "Content.PollWeighting.Text.DefaultWeight": "Le facteur de pondération par défaut est utilisé lorsqu'aucun facteur de pondération n'est disponible pour un participant. Définissez le facteur de pondération par défaut sur 0 si vous ne souhaitez pas appliquer de facteur de pondération aux participants qui ne figurent pas dans la liste des facteurs de pondération.",
    "Content.PollWeighting.Heading.ImportList": "Importer la liste",
    "Content.PollWeighting.Text.ImportList": "Importez un document Excel avec deux colonnes : une pour l'adresse e-mail et une pour le facteur de pondération (nombre). Ce facteur de pondération sera ensuite utilisé pour calculer les résultats du sondage. <strong>Le document ne doit contenir ni titres ni en-têtes.</strong>",
    "Content.PollWeighting.NoWeights": "Aucun facteur de pondération n'a encore été ajouté.",
    "Content.PollWeighting.Heading.List": "Liste des facteurs de pondération",
    "Content.PollWeighting.PageHeading": "Pondération des sondages",
    "Content.PollWeighting.Table.Heading.Email": "Adresse e-mail",
    "Content.PollWeighting.Table.Heading.Factor": "Facteur de pondération",
    "Content.PollWeighting.Table.Button.DeleteEntry": "Supprimer {{email}} de la liste des facteurs de pondération",

    "Content.Slides.ConfirmDelete.Title": "Supprimer la diapositive",
    "Content.Slides.ConfirmDelete.Msg": "Êtes-vous sûr de vouloir supprimer la présentation actuelle ?",
    "Content.Slides.FileLabel": "Fichier",
    "Content.Slides.PageHeading": "Diapositives",
    "Content.Slides.PreviewHeading": "Aperçu",
    "Content.Slides.SlidesAmountLabel": "Nombre de diapositives",
    "Content.Slides.Status.Error": "Votre présentation est en cours de traitement",
    "Content.Slides.Status.Processing": "Votre présentation est en cours de traitement",
    "Content.Slides.Status.Queued": "Votre présentation a été mise en file d'attente pour le traitement",
    "Content.Slides.Status.Success": "Fichier téléchargé avec succès",
    "Content.Slides.Restrictions": "<bold>PDF</bold>",
    "Content.Slides.ReadOnly": "Ce webinaire a déjà été diffusé. Vous pouvez modifier les diapositives dans l'éditeur à la demande.",

    "Dashboard.Heading.Upcoming": "Webinaires à venir",
    "Dashboard.Heading.UpNext": "Prochainement",
    "Dashboard.Link.AllEvents": "Afficher tous les webinaires à venir",
    "Dashboard.PageHeading": "Tableau de bord",

    "DefaultSurvey.Title": "Sondage",
    "DefaultSurvey.Intro": "Souhaitez-vous remplir le sondage ?",
    "DefaultSurvey.Outro": "Merci d'avoir rempli le sondage.",
    "DefaultSurvey.Question.OverallRating": "Quelle est votre évaluation globale de ce webinaire sur une échelle de 1 (très faible) à 10 (excellent) ?",
    "DefaultSurvey.Question.SpeakerRating": "Quel est votre jugement sur le(s) orateur(s) sur une échelle de 1 (très faible) à 10 (excellent) ?",
    "DefaultSurvey.Question.ContentRating": "Qu'avez-vous pensé du contenu du webinaire sur une échelle de 1 (très faible) à 10 (excellent) ?",
    "DefaultSurvey.Question.QuestionRating": "Si vous aviez une question, y a-t-il été répondu de manière satisfaisante ?",
    "DefaultSurvey.Question.WouldRecommend": "Souhaitez-vous participer à de futurs webinaires ?",
    "DefaultSurvey.Question.OpenQuestion": "Si vous avez des questions ou des commentaires, vous pouvez les mentionner ici.",
    "DefaultSurvey.Answer.Yes": "Oui",
    "DefaultSurvey.Answer.No": "Non",
    "DefaultSurvey.Answer.Other": "Autre",

    "EditExam.Info.ZeroMeansUnlimitedRetries": "Indiquez le nombre de fois que le participant peut repasser l'examen. Si la valeur est 0 (zéro), cela signifie que l'examen peut être repassé un nombre infini de fois.",
    "EditExam.Heading.Failed": "Texte d'échec à l'examen",
    "EditExam.Heading.Intro": "Texte d'introduction",
    "EditExam.Heading.Outro": "Texte de remerciement",
    "EditExam.Heading.Passed": "Texte d'examen réussi",
    "EditExam.Heading.Questions": "Questions",
    "EditExam.Heading.Settings": "Paramètres",
    "EditExam.Label.AllowRetries": "Permettre au participant de repasser l'examen",
    "EditExam.Label.Enable": "Enable exam",
    "EditExam.Label.Failed": "Texte d'échec à l'examen",
    "EditExam.Label.Intro": "Texte d'introduction",
    "EditExam.Label.MaximumRetries": "Le nombre de reprises",
    "EditExam.Label.Outro": "Texte de remerciement",
    "EditExam.Label.Passed": "Texte d'examen réussi",
    "EditExam.Label.PassingScore": "Le score pour réussir l'examen",
    "EditExam.Label.Required": "L'examen est obligatoire",
    "EditExam.Label.ShowResult": "Montrer le résultat de l'examen au participant",
    "EditExam.Label.ShowWrongAnswers": "Afficher les questions auxquelles le participant a répondu incorrectement",
    "EditExam.Label.Title": "Titre de l'examen",
    "EditExam.NoQuestions": "L'examen ne contient aucune question",
    "EditExam.Pageheading": "Examen",
    "EditExam.Save.Saved": "Enregistré",
    "EditExam.Save.Saving": "Enregistrement de vos modifications",
    "EditExam.Save.Error": "Erreur lors de l'enregistrement de l'examen",
    "EditExam.Tab.Failed": "Échoué",
    "EditExam.Tab.Intro": "Introduction",
    "EditExam.Tab.Outro": "Conclusion",
    "EditExam.Tab.Passed": "Passé",
    "EditExam.Tab.Questions": "Questions",
    "EditExam.Tab.Settings": "Paramètres",
    "EditExam.Validation.FailedRequired": "Le texte « Échec de l'examen » est obligatoire",
    "EditExam.Validation.IntroRequired": "Le texte d'introduction est obligatoire",
    "EditExam.Validation.OutroRequired": "Le texte de remerciement est obligatoire",
    "EditExam.Validation.PassedRequired": "Le texte « Examen réussi » est obligatoire",
    "EditExam.Validation.QuestionsRequired": "Les questions sont obligatoires",
    "EditExam.Validation.TitleRequired": "Un titre pour l'examen est obligatoire",

    "EditFollowUp.Heading.EmailTemplate": "Modèle d'e-mail de suivi",
    "EditFollowUp.Label.BccOwner": "Ajouter l'organisateur en Cci",
    "EditFollowUp.Label.MinimumExamAnswers": "Nombre minimum de questions d'examen auxquelles il faut répondre",
    "EditFollowUp.Label.MinimumExamPoints": "Nombre minimum de points d'examen",
    "EditFollowUp.Label.MinimumOnlinePercentage": "Pourcentage minimum regardé",
    "EditFollowUp.Label.MinimumPollPoints": "Nombre minimum de points de sondage",
    "EditFollowUp.Label.MinimumPollVotes": "Nombre minimum de votes par sondage",
    "EditFollowUp.Label.MinimumSurveyAnswers": "Nombre minimum de réponses à l'enquête",
    "EditFollowUp.Label.Name": "Nom",
    "EditFollowUp.PageHeading": "Modifier l'e-mail de suivi",
    "EditFollowUp.Toast.Error": "Une erreur s'est produite. Le suivi n'a pas été enregistré.",
    "EditFollowUp.Toast.Saved": "Suivi enregistré",
    "EditFollowUp.Toast.Saving": "Suivi des sauvegardes",

    "EditQuestionnaire.Button.AddMultipleChoiceQuestion": "Question à choix multiples",
    "EditQuestionnaire.Button.AddSingleChoiceQuestion": "Question à choix unique",
    "EditQuestionnaire.Button.AddOpenQuestion": "Question ouverte",
    "EditQuestionnaire.Button.AddOption": "Ajouter une réponse",
    "EditQuestionnaire.Button.DeleteQuestion": "Supprimer la question",
    "EditQuestionnaire.Button.EditQuestion": "Modifier la question",
    "EditQuestionnaire.Button.MoveDown": "Déplacer la réponse vers le bas",
    "EditQuestionnaire.Button.MoveUp": "Déplacer la réponse vers le haut",
    "EditQuestionnaire.Button.QuestionSortDown": "Déplacer la question vers le bas",
    "EditQuestionnaire.Button.QuestionSortUp": "Déplacer la question vers le haut",
    "EditQuestionnaire.Button.RemoveOption": "Supprimer cette réponse",
    "EditQuestionnaire.Heading.MultipleChoiceQuestion": "Question à choix multiples",
    "EditQuestionnaire.Heading.Options": "Réponses",
    "EditQuestionnaire.Heading.OpenQuestion": "Question ouverte",
    "EditQuestionnaire.Heading.SingleChoiceQuestion": "Question à choix unique",
    "EditQuestionnaire.Label.HasOtherOption": "Inclure l'option 'autre'",
    "EditQuestionnaire.Label.Option": "Réponse {{number}}",
    "EditQuestionnaire.Label.OptionValue": "Valeur",
    "EditQuestionnaire.Label.OtherOptionText": "Texte de l'option 'autre'",
    "EditQuestionnaire.Label.Question": "Question",
    "EditQuestionnaire.Label.RequiredQuestion": "Cette question est obligatoire",
    "EditQuestionnaire.QuestionDetail.Options": "Réponses :",
    "EditQuestionnaire.QuestionDetail.OtherOptionText": ", y compris l'option autre",
    "EditQuestionnaire.QuestionDetail.Question": "Question :",
    "EditQuestionnaire.QuestionDetail.Required": "Obligatoire :",
    "EditQuestionnaire.Validation.OptionTextRequired": "La réponse {{option}} à la question numéro {{question}} manque de texte",
    "EditQuestionnaire.Validation.OptionValueRequired": "La réponse {{option}} de la question {{question}} n'a pas de valeur valide",
    "EditQuestionnaire.Validation.OptionsRequired": "Réponses manquantes au numéro de question {{question}}",
    "EditQuestionnaire.Validation.OtherOptionTextRequired": "Texte d'option 'autre' manquant pour la question numéro {{question}}",
    "EditQuestionnaire.Validation.QuestionRequired": "Question manquante au numéro de question {{question}}",

    "EditSubtitles.Button.Delete": "Supprimer les sous-titres {{name}}",
    "EditSubtitles.Button.Download": "Télécharger les sous-titres {{name}}",
    "EditSubtitles.Button.GenerateSubtitles": "Générer des sous-titres",
    "EditSubtitles.Button.GeneratorSubtitles": "Démarrer le générateur de sous-titres",
    "EditSubtitles.DragDrop.AcceptedFileTypes": ".srt and .vtt",
    "EditSubtitles.GenerateSubtitlesOptions.DeepgramSettings": "Paramètres Deepgram",
    "EditSubtitles.GenerateSubtitlesOptions.Title": "Générer des sous-titres",
    "EditSubtitles.GeneratorSubtitles.InfoText": "Si votre contenu à la demande ne comporte pas de sous-titres, vous pouvez les générer automatiquement. Si des sous-titres ont été générés pendant le webinaire en direct, il peut être judicieux de les régénérer afin d'obtenir une traduction plus précise.",
    "EditSubtitles.GeneratorStatus.Generating": "Les sous-titres sont en cours de génération",
    "EditSubtitles.PageHeading": "Modifier les sous-titres",
    "EditSubtitles.TableHeader.Default": "Défaut",
    "EditSubtitles.TableHeader.Enabled": "Activé",
    "EditSubtitles.TableHeader.TrackId": "ID de la piste",

    "EditSurvey.Heading.Intro": "Texte d'introduction",
    "EditSurvey.Heading.Outro": "Texte de remerciement",
    "EditSurvey.Heading.Questions": "Questions",
    "EditSurvey.Label.Enabled": "Activer l'enquête",
    "EditSurvey.Label.Intro": "Texte d'introduction",
    "EditSurvey.Label.Outro": "Texte de remerciement",
    "EditSurvey.Label.Required": "L'enquête est obligatoire",
    "EditSurvey.Label.Title": "Titre de l'enquête",
    "EditSurvey.NoQuestions": "L'enquête ne contient aucune question",
    "EditSurvey.Pageheading": "Enquête",
    "EditSurvey.Save.Saved": "Enregistré",
    "EditSurvey.Save.Saving": "Enregistrement de vos modifications",
    "EditSurvey.Save.Error": "Erreur lors de l'enregistrement de l'enquête",
    "EditSurvey.Tab.Intro": "Introduction",
    "EditSurvey.Tab.Outro": "Conclusion",
    "EditSurvey.Tab.Questions": "Questions",
    "EditSurvey.Validation.IntroRequired": "Le texte d'introduction est obligatoire",
    "EditSurvey.Validation.OutroRequired": "Le texte de remerciement est obligatoire",
    "EditSurvey.Validation.QuestionsRequired": "Les questions sont obligatoires",
    "EditSurvey.Validation.TitleRequired": "Le titre est obligatoire",

    "Editor.Button.Save": "Enregistrer",
    "Editor.Button.SaveOndemand": "Enregistrer à la demande",
    "Editor.Button.MoveToIndicator": "Déplacer vers l'indicateur",
    "Editor.Chapter.Button.Add": "Ajouter un nouveau chapitre",
    "Editor.Chapter.Button.Delete": "Supprimer le chapitre",
    "Editor.Chapter.Heading": "Modifier le chapitre",
    "Editor.Chapter.New": "Chapitre",
    "Editor.Chapter.Title.Label": "Titre du chapitre",
    "Editor.Chat.Button.Add": "Ajouter un nouveau message de discussion",
    "Editor.Chat.Button.Delete": "Supprimer le message de discussion",
    "Editor.Chat.Message.Label": "Texte du message de discussion",
    "Editor.Chat.Heading": "Modifier le message de discussion",
    "Editor.Download.Video.Button": "Télécharger la vidéo MP4",
    "Editor.Download.Video.Heading": "Télécharger la vidéo originale",
    "Editor.Download.Video.Text": "Vous pouvez télécharger la vidéo originale au format MP4. Les coupes effectuées à l'aide de l'éditeur ne seront pas appliquées à cette vidéo.",
    "Editor.PageHeading": "Éditeur",
    "Editor.Publishing.Modal.Close": "Fermer ce message",
    "Editor.Publishing.Modal.Error": "Une erreur s'est produite lors de l'enregistrement de vos modifications.",
    "Editor.Publishing.Modal.Success": "Vos modifications ont été enregistrées avec succès !",
    "Editor.Publishing.Modal.Progress.Label": "État d'avancement de la publication :",
    "Editor.Publishing.Modal.Publishing": "Enregistrement de vos modifications",
    "Editor.Publishing.Modal.PublishingHeader": "Publication des modifications",
    "Editor.Publishing.Modal.PublishingDescription": "Une fois les modifications enregistrées, elles seront visibles à la demande.",
    "Editor.Publishing.Modal.KeyframeExtraction": "Extraction des images clés",
    "Editor.Publishing.Modal.KeyframeExtractionHeader": "Extraction des images clés",
    "Editor.Publishing.Modal.KeyframeExtractionDescription": "Les images clés sont extraites de la vidéo. Cela peut prendre un certain temps en fonction de la longueur de la vidéo.",
    "Editor.Publishing.Modal.Encoding": "éencodage",
    "Editor.Publishing.Modal.EncodingHeader": "éencodage de la vidéo",
    "Editor.Publishing.Modal.EncodingDescription": "La vidéo est réencodée avec les modifications appliquées. Cela peut prendre un certain temps en fonction de la longueur de la vidéo.",
    "Editor.Publishing.Modal.GetDurationStep": "Getting video duration",
    "Editor.Publishing.Modal.EncodeStep": "Reencoding video",
    "Editor.Publishing.Modal.CreateHlsStep": "Creating HLS video",
    "Editor.Publishing.Modal.KeyframeExtractionStep": "Extracting keyframes",
    "Editor.Publishing.Modal.CleanupStep": "Cleaning up",
    "Editor.Poll.Button.Delete": "Supprimer le sondage",
    "Editor.Poll.Button.Next": "Sondage suivant",
    "Editor.Poll.Button.Previous": "Sondage précédent",
    "Editor.Poll.Heading": "Modifier le sondage",
    "Editor.SaveInfoText": "Les modifications apportées dans l'éditeur seront visibles à la demande après avoir cliqué sur 'Enregistrer à la demande'.",
    "Editor.Slides.Button.Add": "Ajouter une nouvelle diapositive",
    "Editor.Slides.Button.Delete": "Supprimer la diapositive",
    "Editor.Slides.Button.Replace": "Remplacer la diapositive",
    "Editor.Slides.Heading": "Modifier la diapositive",
    "Editor.Timeline.Zoom.Text": "Zoom sur la chronologie :",
    "Editor.Timestamp.Legend": "Heure de début",
    "Editor.Trackname.Chapters": "Chapitres",
    "Editor.Trackname.Chat": "Discussion",
    "Editor.Trackname.Polls": "Sondages",
    "Editor.Trackname.Slides": "Diapositives",
    "Editor.Trackname.VideoLayout": "Disposition vidéo",
    "Editor.TrimVideo.Button.Delete": "Supprimer la coupe vidéo",
    "Editor.TrimVideo.Heading": "Couper la vidéo",
    "Editor.TrimVideo.TrimNumber": "Coupe {{number}}",
    "Editor.Upload.Button": "Télécharger une vidéo",
    "Editor.Upload.Button.Cancel": "Annuler le chargement",
    "Editor.Upload.Button.Pause": "Interrompre le chargement",
    "Editor.Upload.Button.Resume": "Reprenez le chargement",
    "Editor.Upload.DragDrop.AcceptedFileTypes": ".3g2, .3gp, .avi, .flv, .h264, .mkv, .mov, .mp4, .mpeg, .mpg, .qt, .webm et .wmv",
    "Editor.Upload.Heading": "Télécharger une vidéo",
    "Editor.Upload.Paused": "Le chargement de la vidéo est suspendu.",
    "Editor.Upload.Progress.Label": "Téléchargement de la vidéo",
    "Editor.VideoBeingAnalyzed": "Veuillez patienter, la vidéo est en cours d'analyse",
    "Editor.VideoLayout.Heading": "Modifier la disposition vidéo",
    "Editor.VideoLayout.Item.Classic": "Classique",
    "Editor.VideoLayout.Item.Default": "Par défaut",
    "Editor.VideoLayout.Item.DesktopSharing": "Partage d'écran",
    "Editor.VideoLayout.Item.PresentationWithVideoLarge": "Vidéo avec petites diapositives",
    "Editor.VideoLayout.Item.PresentationWithVideoSmall": "Diapositives avec petite vidéo",
    "Editor.VideoLayout.Item.UnknownLayout": "Disposition vidéo inconnue",
    "Editor.VideoLayout.Item.VideoOnly": "Vidéo uniquement",

    "Email.Preview.Heading": "Aperçu",
    "Email.Preview.Updating": "Mise à jour de l'aperçu",
    "Email.Style.Error.InvalidStyle": "Style invalide",
    "Email.Style.HeaderImage.AcceptedTypes": "JPG, PNG, GIF et WebP",
    "Email.Style.HeaderImage.AltTextInfo": "Décrivez l'image si elle contient une information, comme un logo avec du texte. Laissez vide pour une image purement décorative.",
    "Email.Style.HeaderImage.Button.UseDefault": "Utiliser l'image par défaut",
    "Email.Style.HeaderImage.CurrentImageAlt": "Image d'en-tête actuelle de l'e-mail",
    "Email.Style.HeaderImage.FileLimits": "10 Mo maximum. Un GIF animé ne conserve que sa première image.",
    "Email.Style.HeaderImage.Heading": "Image d'en-tête",
    "Email.Style.HeaderImage.Info": "L'image est recadrée autour du centre à 580 × 160 pixels et enregistrée en JPG ou en PNG, selon le format le plus léger. Une nouvelle image ne s'applique qu'aux e-mails envoyés à partir de maintenant.",
    "Email.Style.HeaderImage.Label.AltText": "Texte alternatif de l'image d'en-tête",
    "Email.Style.HeaderImage.Warning.NoPlaceholder": "Le modèle ci-dessous ne contient pas @HeaderImageUrl : l'image d'en-tête n'apparaîtra donc pas dans les e-mails. Utilisez src=\"@HeaderImageUrl\" alt=\"@HeaderImageAlt\" sur l'image d'en-tête.",
    "Email.Style.HeaderImage.Warning.TooSmall": "Cette image fait moins de 580 × 160 pixels. Elle sera agrandie et risque d'être floue.",
    "Email.Style.Label.Button": "Style du bouton",
    "Email.Style.Label.Code": "Style du code",
    "Email.Style.Label.Heading": "Style du titre {{level}}",
    "Email.Style.Label.Paragraph": "Style du paragraphe",
    "Email.Style.Label.Template": "Modèle",
    "Email.Style.PageHeading": "Style de modèle d'e-mail",
    "Email.Style.Warning": "Remarque : le modèle et les styles seront nettoyés pour éviter les attaques XSS, vérifiez si les styles sont toujours corrects après l'enregistrement.",
    "Email.Template.Label.Body": "Corps",
    "Email.Template.Label.IncludeCalendarAttachment": "Inclure la pièce jointe calendrier (.ics)",
    "Email.Template.Label.SelectTemplate": "Sélectionner le modèle d'e-mail",
    "Email.Template.Label.Subject": "Objet",
    "Email.Template.PageHeading": "Modèle d'e-mail",

    "EmailStatus.Failed": "Échoué",
    "EmailStatus.Queued": "En file d'attente",
    "EmailStatus.Sending": "Envoi",
    "EmailStatus.Sent": "Envoyé",

    "FollowUpOverview.Button.CreateFollowUp": "Créer un suivi",
    "FollowUpOverview.Button.Delete": "Supprimer le suivi {{name}}",
    "FollowUpOverview.Button.Edit": "Modifier le suivi {{name}}",
    "FollowUpOverview.InfoText": "Vous pouvez définir ici un ou plusieurs e-mails de suivi. Un e-mail de suivi sera envoyé lorsque certaines conditions seront remplies. Par exemple, lorsqu'un participant aura visionné l'intégralité du webinaire ou réussi un examen.",
    "FollowUpOverview.NoFollowUps": "Il n'y a pas d'e-mail de suivi actif pour ce webinaire.",
    "FollowUpOverview.PageHeading": "Courriel de suivi",
    "FollowUpOverview.TableHeader.BccOwner": "BCC l'organisateur",
    "FollowUpOverview.TableHeader.Name": "Nom",
    "FollowUpOverview.TableHeader.Processed": "Envoyé",

    "Footer.Link.CookiePolicy": "Politique de cookies",
    "Footer.Link.PrivacyPolicy": "Politique de confidentialité",
    "Footer.Link.Support": "Support",
    "Footer.Link.TermsOfUse": "Conditions générales d'utilisation",

    "Generic.ApiErrorCode.Exception": "Quelque chose s'est mal passé",
    "Generic.ApiErrorCode.Exception.Body": "Quelque chose s'est mal passé, veuillez actualiser la page ou réessayer plus tard.",
    "Generic.ApiErrorCode.NotFoundException": "Non trouvé",
    "Generic.ApiErrorCode.NotFoundException.Body": "La page que vous recherchez n'existe plus.",
    "Generic.ApiErrorCode.NotPublishedException": "Non publié",
    "Generic.ApiErrorCode.NotPublishedException.Body": "Le webinaire que vous recherchez n'est pas actuellement publié.",
    "Generic.ApiErrorCode.CancelledException": "Annulé",
    "Generic.ApiErrorCode.CancelledException.Body": "Le webinaire que vous recherchez a été annulé.",
    "Generic.ApiErrorCode.ExpiredException": "Expiré",
    "Generic.ApiErrorCode.ExpiredException.Body": "Le webinaire que vous recherchez a expiré.",
    "Generic.ApiErrorCode.AccessDeniedException": "Accès refusé",
    "Generic.ApiErrorCode.AccessDeniedException.Body": "Vous n'avez pas accès à cette page.",
    "Generic.ApiErrorCode.AccountNotVerifiedException": "Compte non vérifié",
    "Generic.ApiErrorCode.AccountNotVerifiedException.Body": "Cette fonctionnalité n'est disponible que pour les comptes vérifiés.",
    "Generic.ApiErrorCode.ServiceUnavailableException": "Temporairement indisponible",
    "Generic.ApiErrorCode.ServiceUnavailableException.Body": "La plateforme est en maintenance. Veuillez réessayer dans quelques minutes.",

    "Generic.Button.AriaLabel.isLoading": "Traitement en cours",
    "Generic.Loading": "Chargement",
    "Generic.Button.Back": "Retourner",
    "Generic.Button.Cancel": "Annuler",
    "Generic.Button.Continue": "Continuer",
    "Generic.Button.Delete": "Supprimer",
    "Generic.Button.Details": "Détails",
    "Generic.Button.Export": "Exporter",
    "Generic.Button.Save": "Enregistrer",
    "Generic.Button.SaveChanges": "Enregistrer les modifications",
    "Generic.Button.TryAgain": "Essayer à nouveau",
    "Generic.Button.UploadImage": "Télécharger l'image",
    "Generic.Button.Watch": "Regarder",

    "Generic.Dialog.Button.Close": "Fermer",
    "Generic.DragDrop": "Glisser & Déposer",
    "Generic.DragDrop.AcceptedImageTypes": "JPG, PNG et WEBP",
    "Generic.DragDrop.AcceptedText": "Les fichiers suivants sont acceptés : ",
    "Generic.DragDrop.Active": "Déposez les fichiers ici ...",
    "Generic.DragDrop.BrowseFiles": "ou <span>parcourir</span> vos fichiers",
    "Generic.FileRejection.FileInvalidType": "Ce type de fichier n'est pas pris en charge ici.",
    "Generic.FileRejection.FileTooLarge": "Ce fichier est trop volumineux.",
    "Generic.FileRejection.FileTooSmall": "Ce fichier est trop petit.",
    "Generic.FileRejection.TooManyFiles": "Vous ne pouvez ajouter qu'un seul fichier à la fois ici.",
    "Generic.FileRejection.Unknown": "Ce fichier ne peut pas être utilisé ici.",
    "Generic.Link.Context": " : {{title}}",
    "Generic.Link.Logo": "{{site}} - {{page}}",
    "Generic.Link.OpensInNewTab": "(s'ouvre dans un nouvel onglet)",
    "Generic.Link.ViewDetails": "Voir les détails",
    "Generic.Link.WebinarSchedule": "Programme du webinaire",
    "Generic.And": "et",
    "Generic.Days": "jours",
    "Generic.Hour": "heures",
    "Generic.Hour.Full": "Heures",
    "Generic.Minute": "min",
    "Generic.Minute.Full": "Minutes",
    "Generic.Second": "sec",
    "Generic.Second.Full": "Secondes",
    "Generic.Interested": "Intéressé",
    "Generic.NotInterested": "Pas intéressé",
    "Generic.Skiplink": "Passer au contenu principal",

    "Image.AltText": "Texte alternatif",
    "Image.AltText.Explanation": "Décrivez ce que montre ou signifie l'image, par exemple le texte qu'elle contient. Laissez ce champ vide si l'image est purement décorative. 250 caractères maximum.",
    "ImportInvites.Button.Import": "Importer des participants",
    "ImportInvites.Dialog.Progress": "Importation de {{current}} sur {{total}}",
    "ImportInvites.Dialog.Title": "Importation des participants",
    "ImportInvites.DragDrop.AcceptedFileTypes": ".xls, .xlsx, .csv, .ods, .fods et .txt",
    "ImportInvites.ErrorMessage.WorkBookError": "Au moins l'adresse e-mail est requise pour être importée",
    "ImportInvites.Label.HasHeader": "Le document contient un en-tête",
    "ImportInvites.Label.Worksheet": "Choisir une feuille de calcul",
    "ImportInvites.MapOption.NotImported": "Non importé",
    "ImportInvites.PageHeading": "Importer des participants",
    "ImportInvites.Text.HasHeader": "Si votre document contient des en-têtes, veuillez sélectionner l'option ci-dessous :",
    "ImportInvites.Text.NoDataRows": "Aucune ligne de données n'a été trouvée dans ce fichier. Si votre fichier ne contient pas de ligne d'en-tête, désactivez « Le document contient un en-tête » ci-dessus.",
    "ImportInvites.Text.MapColumns": "Veuillez sélectionner une propriété dans la liste pour chaque colonne du tableau, afin que nous puissions importer correctement vos données.",
    "ImportInvites.Text.MultipleWorksheets": "Votre document comprend plusieurs feuilles de calcul. Sélectionnez la feuille de calcul que vous souhaitez importer :",

    "Insights.Chat.AmountText": "Nombre de messages de discussion :",
    "Insights.Chat.Button.Export": "Exporter les messages de discussion",
    "Insights.Chat.PageHeading": "Messages de discussion",
    "Insights.Exam.AmountText": "Nombre de questions d'examen posées :",
    "Insights.Exam.PageHeading": "Résultats des examens",
    "Insights.Exam.Button.Export": "Exporter les résultats",
    "Insights.Exam.Label.Result": "Résultat",
    "Insights.Exam.Label.Score": "Score",
    "Insights.Exam.Result.Failed": "Échoué",
    "Insights.Exam.Result.Passed": "Passé",
    "Insights.Exam.Select.Combined": "Résultats des examens combinés",
    "Insights.Exam.Select.Label": "Afficher les résultats des examens",
    "Insights.Exam.Select.Live": "Résultats des examens en direct",
    "Insights.Exam.Select.OnDemand": "Résultats d'examen à la demande",
    "Insights.Exam.Tab.ParticipantDetails": "Détails des participants",
    "Insights.Exam.Tab.AnswersOverview": "Aperçu des réponses",
    "Insights.Interested.PageHeading": "Comptes intéressés",
    "Insights.Live.AmountText.Single": "participant a regardé en direct",
    "Insights.Live.AmountText.Multiple": "participants ont regardé en direct",
    "Insights.Live.PageHeading": "Participants en direct",
    "Insights.OnDemand.AmountText.Single": "participant a regardé à la demande",
    "Insights.OnDemand.AmountText.Multiple": "participants ont regardé à la demande",
    "Insights.OnDemand.PageHeading": "Participants à la demande",
    "Insights.Polls.AmountText": "Nombre de questions de sondage posées :",
    "Insights.Polls.Button.Export": "Exporter les résultats du sondage",
    "Insights.Polls.PageHeading": "Résultats du sondage",
    "Insights.Polls.Select.Combined": "Résultats du sondage combinés",
    "Insights.Polls.Select.Label": "Afficher les résultats du sondage",
    "Insights.Polls.Select.Live": "Résultats du sondage en direct",
    "Insights.Polls.Select.OnDemand": "Résultats du sondage à la demande",
    "Insights.Survey.AmountText": "Nombre de questions d'enquête posées :",
    "Insights.Survey.PageHeading": "Résultats de l'enquête",
    "Insights.Survey.Button.Export": "Exporter les résultats",
    "Insights.Survey.Select.Combined": "Résultats de l'enquête combinés",
    "Insights.Survey.Select.Label": "Afficher les résultats de l'enquête",
    "Insights.Survey.Select.Live": "Résultats de l'enquête en direct",
    "Insights.Survey.Select.OnDemand": "Résultats de l'enquête à la demande",

    "Invites.Button.DeleteParticipant": "Supprimer {{email}} des participants importés",
    "Invites.Button.EmailPending": "Envoyer les invitations en attente par e-mail",
    "Invites.Button.EmailReminder": "Envoyer les rappels par e-mail",
    "Invites.Button.Import": "Importer des participants",
    "Invites.Button.ResendAllInvites": "Renvoyer toutes les invitations",
    "Invites.Button.ResendAllReminders": "Renvoyer tous les rappels",
    "Invites.Settings.AutoSendInvite": "Envoyer l'invitation automatiquement après l'import",
    "Invites.Settings.AutoSendReminder": "Envoyer le rappel automatiquement",
    "Invites.Settings.ReminderHoursBeforeWebinar": "Heures avant le webinaire",
    "Invites.Button.ResetInvite": "Renvoyer l'invitation à {{email}}",
    "Invites.Dialog.Emailing.Progress": "Envoi de {{current}} sur {{total}}",
    "Invites.Dialog.Emailing.Title": "Envoi d'e-mails",
    "Invites.Heading.ImportedParticipants": "Participants importés",
    "Invites.PageHeading": "Inviter des participants",

    "Campaign.New": "Nouvelle campagne",
    "Campaign.NewName": "Nouvelle campagne",
    "Campaign.Table.Name": "Nom",
    "Campaign.Table.Created": "Créée le",
    "Campaign.Table.Status": "Statut",
    "Campaign.Table.Sent": "Envoyés",
    "Campaign.Table.InterestedNow": "Intéressés maintenant",
    "Campaign.Status.Draft": "Brouillon",
    "Campaign.Status.Sent": "Envoyée",
    "Campaign.Field.Name": "Nom de la campagne",
    "Campaign.Field.Name.Edit": "Modifier le nom de la campagne",
    "Campaign.Tab.Audience": "Audience",
    "Campaign.Tab.Addresses": "Adresses",
    "Campaign.Tab.EmailTemplate": "Modèle d'e-mail",
    "Campaign.Lists.Heading": "Audience",
    "Campaign.Lists.Webinar": "Listes du webinaire",
    "Campaign.Lists.Global": "Listes globales",
    "Campaign.Lists.CreateWebinarList": "Importer une nouvelle liste pour ce webinaire",
    "Campaign.Lists.SelectExistingList": "Sélectionner une liste existante",
    "Campaign.Lists.AddSelected": "Ajouter la sélection",
    "Campaign.Lists.NoGlobalLists": "Aucune liste globale disponible à ajouter.",
    "Campaign.Lists.RemoveGlobalList": "Retirer la liste {{name}}",
    "Campaign.Lists.DeleteWebinarList": "Supprimer la liste {{name}}",
    "Campaign.Send": "Envoyer",
    "Campaign.Warning.NotPublished": "L'envoi est impossible car le webinaire n'est pas encore publié.",

    "Campaign.CannotSend.Header": "Cet e-mail ne peut pas encore être envoyé :",
    "Campaign.CannotSend.IncompleteSubject": "Saisissez un sujet pour le modèle d'e-mail",
    "Campaign.CannotSend.IncompleteBody": "Complétez le corps du modèle d'e-mail",
    "Campaign.CannotSend.NoLists": "Sélectionnez au moins une liste",
    "Campaign.CannotSend.NotPublished": "Le webinaire n'est pas publié",
    "Campaign.Delete": "Supprimer la campagne",
    "Campaign.SendConfirm.Title": "Envoyer cette campagne ?",
    "Campaign.SendConfirm.Body": "L'e-mail sera envoyé aux listes sélectionnées. Après l'envoi, la campagne ne pourra plus être modifiée.",
    "Campaign.DeleteConfirm.Title": "Supprimer cette campagne ?",
    "Campaign.DeleteConfirm.Body": "Cela supprimera définitivement la campagne. Cette action est irréversible.",
    "Campaign.Detail.SentAt": "Envoyée le",
    "Campaign.Detail.NotSent": "Pas encore envoyée",
    "Campaign.Detail.RecipientCount": "Destinataires",
    "Campaign.Detail.EstimatedRecipients": "Destinataires (estimés)",
    "Campaign.Detail.Sent": "Envoyés",
    "Campaign.Detail.Failed": "Échecs",
    "Campaign.Detail.Blacklisted": "Sur liste noire",
    "Campaign.Detail.AlreadyInterested": "Déjà intéressés",
    "Campaign.Detail.AlreadySentInAnotherList": "Ignoré (autre liste)",
    "Campaign.Detail.InterestedNow": "Intéressés maintenant",
    "Campaign.Detail.RecipientsHeading": "Destinataires",
    "Campaign.AddLists.Heading": "Envoyer à d'autres listes",
    "Campaign.AddLists.Intro": "Ajoutez d'autres listes pour toucher de nouvelles personnes. Toute adresse déjà présente dans cette campagne est automatiquement ignorée.",
    "Campaign.AddLists.Button": "Ajouter et envoyer",
    "Campaign.AddLists.NoSelectionHint": "Sélectionnez au moins une liste à envoyer.",
    "Campaign.AddLists.None": "Toutes vos listes pour ce webinaire sont déjà dans cette campagne.",
    "Campaign.Recipients.Search": "Rechercher",
    "Campaign.Recipients.StatusFilter": "Filtrer par statut",
    "Campaign.Recipients.AllStatuses": "Tous les statuts",
    "Campaign.Recipients.Email": "Adresse e-mail",
    "Campaign.Recipients.Name": "Nom",
    "Campaign.Recipients.Company": "Entreprise",
    "Campaign.Recipients.List": "Liste",
    "Campaign.Recipients.SentAt": "Envoyé le",
    "Campaign.Recipients.Status": "Statut",
    "Campaign.Recipients.Empty": "Aucun destinataire trouvé.",
    "Campaign.RecipientStatus.Pending": "En attente",
    "Campaign.RecipientStatus.Sent": "Envoyé",
    "Campaign.RecipientStatus.Failed": "Échec",
    "Campaign.RecipientStatus.Blacklisted": "Sur liste noire",
    "Campaign.RecipientStatus.AlreadyInterested": "Déjà intéressé",
    "Campaign.RecipientStatus.AlreadySentInAnotherList": "Ignoré (autre liste)",
    "Campaign.SelectList.Heading": "Sélectionner une liste",
    "Campaign.SelectList.Back": "Retour aux listes",
    "Campaign.SelectList.UseList": "Utiliser cette liste",
    "Campaign.SelectList.Empty": "Aucune liste disponible.",

    "Generic.Pagination.Previous": "Précédent",
    "Generic.Pagination.Next": "Suivant",
    "Generic.Pagination.PageOf": "Page {{page}} sur {{total}}",

    "Invites.Table.Header.InvitedAt": "Invité le",
    "Invites.Table.Header.Status": "Invitation",
    "Invites.Table.Header.ReminderStatus": "Rappel",

    "LiveTranscribe.Label.DeepgramLanguage": "La langue parlée dans ce webinaireLa langue parlée dans ce webinaire",
    "LiveTranscribe.Label.DeepgramDefault": "Utilisez Deepgram comme outil de transcription par défaut",
    "LiveTranscribe.Label.DeepgramEnabled": "Activer la transcription en direct via Deepgram",
    "LiveTranscribe.Label.DeepgramModel": "Modèle Deepgram",
    "LiveTranscribe.Label.SmartFormat": "Activez Smart Format. Smart Format peut formater automatiquement les transcriptions pour améliorer leur lisibilité.",
    "LiveTranscribe.Label.TrackId": "ID de la piste",
    "LiveTranscribe.Option.DeepgramLanguage.Dutch": "Néerlandais",
    "LiveTranscribe.Option.DeepgramLanguage.English": "Anglais",
    "LiveTranscribe.Option.DeepgramLanguage.French": "Français",
    "LiveTranscribe.Option.DeepgramLanguage.German": "Allemand",
    "LiveTranscribe.Option.DeepgramLanguage.Multi": "Plusieurs langues",
    "LiveTranscribe.PageHeading": "Transcription en direct",
    "LiveTranscribe.SectionHeader.DeepgramSettings": "Paramètres Deepgram",

    "MainMenu.Content": "Contenu du webinaire",
    "MainMenu.CreateNew": "Créer un nouveau webinaire",
    "MainMenu.Label": "Menu principal",
    "MainMenu.ManageEnv": "Gérer l'environnement",
    "MainMenu.Overview": "Webinaires organisés",
    "MainMenu.Share": "Partager",
    "MainMenu.Schedule": "Programme du webinaire",
    "MainMenu.Support": "Aide",
    "MainMenu.Toggle.Close": "Fermer le menu",
    "MainMenu.Toggle.Open": "Ouvrir le menu",

    "Manage.Link.AccountInvites": "Inviter des participants",
    "Manage.Link.EmailStyle": "Gérer le style des modèles d'e-mail",
    "Manage.Link.EmailTemplates": "Gérer les modèles d'e-mail",
    "Manage.Link.ManagePrepend": "Gérer",
    "Manage.Link.Translation": "Gérer la traduction",
    "Manage.Link.WebinarDuration": "Afficher les paramètres",
    "Manage.PageHeading": "Gérer l'environnement",

    "Marketing.PageHeading": "Marketing",

    "Menu.Dropdown.Options": "Options",

    "OptionMenu.Content": "Modifier",
    "OptionMenu.EditOnDemand": "Modifier à la demande",
    "OptionMenu.Insights": "Statistiques",
    "OptionMenu.Marketing": "Marketing",
    "OptionMenu.Pay": "Payer maintenant",
    "OptionMenu.Security": "Sécurité",
    "OptionMenu.Share": "Partager",
    "OptionMenu.ShareOnDemand": "Partager à la demande",
    "OptionMenu.SlideController": "Contrôleur de diapositives",
    "OptionMenu.Test": "Test de connexion",
    "OptionMenu.WatchOnDemand": "Regarder à la demande",

    "Pages.404.Header": "Oups",
    "Pages.404.Text": "Nous ne trouvons pas cette page. Vous pouvez aller au le programme des webinaires ou revenir à la page précédente.",
    "Pages.404.SideContent.Header": "Pourquoi ?",
    "Pages.404.SideContent.Text": "Ce n'est pas censé être comme ça !!",
    "Pages.Auth.SideContent.Header": "Bonjour !",
    "Pages.Auth.SideContent.Text": "Bon visionnage de votre webinaire !",
    "Pages.ForgotPassword.Header": "Mot de passe oublié",
    "Pages.Login.Header": "Connectez-vous ou créez un compte",
    "Pages.Organized.Header": "Webinaires organisés",
    "Pages.Organized.Heading.OnDemand": "Webinaires à la demande",
    "Pages.Organized.Heading.Upcoming": "Webinaires à venir",
    "Pages.Organized.NoEnded.Title": "Aucun webinaire terminé",
    "Pages.Organized.NoEnded.Text": "Les webinaires terminés seront listés ici.",
    "Pages.Organized.NoUpcoming.Title": "Rien à voir ici pour l'instant",
    "Pages.Organized.NoUpcoming.Text": "Les webinaires que vous avez organisés apparaîtront ici. Pourquoi ne pas essayer maintenant ?",
    "Pages.Organized.NoUpcoming.Button": "Créer votre propre webinaire",
    "Pages.Organized.TabEnded": "Webinaires terminés",
    "Pages.Organized.TabOnDemand": "Webinaires à la demande",
    "Pages.Organized.TabUpcoming": "Webinaires à venir",
    "Pages.Organized.TabSearch": "Résultats de recherche",
    "Pages.Organized.NotFound.Title": "Aucun résultat trouvé",
    "Pages.Organized.NotFound.Text": "Aucun webinaire ne correspond à votre recherche. Essayez un autre mot-clé.",
    "Pages.Organized.Heading.Found": "Résultats de recherche",
    "Pages.Register.Header": "S'inscrire",
    "Pages.Register.Webinar.CreateAccount": "Pour pouvoir regarder ce webinaire, vous devrez vous connecter avec un compte ou créer un nouveau compte :",
    "Pages.Register.Webinar.Interested": "Vous êtes intéressé par le webinaire suivant :",
    "Pages.Register.WebinarModerator": "Vous êtes invité à modérer le webinaire suivant :",
    "Pages.Register.WebinarModerator.CreateAccount": "Pour modérer ce webinaire, vous devrez vous connecter avec un compte ou créer un nouveau compte :",
    "Pages.Register.WebinarBroadcaster": "Vous êtes invité à diffuser le webinaire suivant :",
    "Pages.Register.WebinarBroadcaster.CreateAccount": "Pour pouvoir diffuser ce webinaire, vous devrez vous connecter avec un compte ou créer un nouveau compte :",

    "Participants.Online": "En ligne :",
    "Participants.Search.Label": "Filtrer",

    "Player.Button.Fullscreen": "Plein écran",
    "Player.Button.ExitFullscreen": "Quitter le mode plein écran",
    "Player.Button.Poll": "Sondage",
    "Player.Button.Subtitles": "Sous-titres",
    "Player.Chapters.Add": "Vous pouvez ajouter des chapitres",
    "Player.Chapters.Heading": "Chapitres",
    "Player.NoChapters": "Aucun chapitre à afficher pour l'instant",
    "Player.Chat.ForwardedFrom": "Message transféré de ",
    "Player.Chat.Global": "Public",
    "Player.Chat.Header": "Discussion",
    "Player.Chat.Nickname.Required": "Veuillez saisir un pseudo pour participer à la discussion.",
    "Player.Chat.Nickname.Placeholder": "Votre pseudo",
    "Player.Chat.Nickname.UpdateButton": "Mettre à jour le pseudo",
    "Player.Chat.InputPlaceHolder": "Avez-vous une question ou un commentaire ? Saisissez votre message ici",
    "Player.Chat.Live.Ended": "Le webinaire est terminé et tous les modérateurs sont hors ligne maintenant, plus de discussion possible",
    "Player.Chat.OnDemand": "Vous pouvez envoyer votre message ici, il sera transmis à l'organisateur de ce webinaire.",
    "Player.Chat.Private": "Support",
    "Player.Chat.Send": "Envoyer le message",
    "Player.Info.State.CountDownWithTime": "Le webinaire commence dans :",
    "Player.Info.State.WebinarStarting": "Un instant s'il vous plaît, le webinaire reprendra dans quelques instants",
    "Player.Menu.Chapters": "Chapitres",
    "Player.Menu.Chat": "Discussion",
    "Player.Menu.NewSlide": "nouvelle diapositive",
    "Player.Menu.Slides": "Diapositives",
    "Player.Menu.UnreadMessages_one": "{{count}} message non lu",
    "Player.Menu.UnreadMessages_other": "{{count}} messages non lus",
    "Player.Menu.Video": "Vidéo",
    "Player.NoPolls": "Aucun sondage à afficher pour l'instant",
    "Player.Poll.ResultsAtEndMessage": "Merci pour votre vote.",
    "Player.SubtitleSelect.NoSubtitles": "Sous-titres désactivés",
    "Player.ThanksForWatching.Button.Replay": "Rejouer",
    "Player.ThanksForWatching.Heading": "Merci d'avoir regardé !",
    "Player.ThanksForWatching.Link.Url": "/",
    "Player.ThanksForWatching.Link.Overview": "Programme du webinaire",
    "Player.Resume.Loading": "Chargement…",
    "Player.Resume.Notice": "Reprise là où vous vous étiez arrêté",
    "Player.Recovery.Reconnecting": "Reconnexion…",
    "Player.Recovery.Failed": "La vidéo n'a pas pu être rétablie.",
    "Player.Recovery.TryAgain": "Réessayer",
    "Player.UserInputButton.Audio": "Activer l'audio",
    "Player.UserInputButton.Play": "Lire",

    "poll.viewIconLabel": "icône-sondage",

    "presentationSlide.NoSlide": "Pas de diapositive à afficher",
    "presentationSlide.Upload": "Veuillez télécharger",

    "ProcessedFollowUp.Button.Export": "Liste d'exportation",
    "ProcessedFollowUp.Heading.SentTo": "Suivi envoyé à",
    "ProcessedFollowUp.PageHeading": "Envoyé suivi",
    "ProcessedFollowUp.TableHeader.CreatedAt": "Envoyé à",
    "ProcessedFollowUp.TableHeader.EmailStatus": "Statut",
    "ProcessedFollowUp.TableHeader.ExamAnswers": "Réponses aux examens",
    "ProcessedFollowUp.TableHeader.ExamPoints": "Points d'examen",
    "ProcessedFollowUp.TableHeader.Name": "Nom",
    "ProcessedFollowUp.TableHeader.OnlinePercentage": "Pourcentage regardé",
    "ProcessedFollowUp.TableHeader.PollPoints": "Points de sondage",
    "ProcessedFollowUp.TableHeader.PollVotes": "Votes par sondage",
    "ProcessedFollowUp.TableHeader.SurveyAnswers": "Réponses à l'enquête",

    "Questionnaire.Accreditation": "L'accréditation est fournie par :",
    "Questionnaire.Button.End": "Fermer",
    "Questionnaire.Button.Next": "Suivant",
    "Questionnaire.Button.Previous": "Retour",
    "Questionnaire.Button.Retry": "Reprendre l'examen",
    "Questionnaire.Button.StartExam": "Passer l'examen",
    "Questionnaire.Exam.WrongAnswers": "Vous avez répondu incorrectement aux questions suivantes :",
    "Questionnaire.OpenQuestion.Placeholder": "Votre réponse",
    "Questionnaire.OtherAnswer.Placeholder": "Veuillez saisir votre réponse.",
    "Questionnaire.Preface": "Préface",
    "Questionnaire.Progress": "Question {{number}} de {{total}}",
    "Questionnaire.Question.Required": "Cette question est obligatoire",
    "Questionnaire.Result": "Résultat",
    "Questionnaire.ResultLoading": "Déterminer votre résultat",
    "Questionnaire.Retakes": "Nombre de reprises disponibles : <strong>{{retakes}}</strong>.",
    "Questionnaire.WrongAnswers": "Vous avez répondu incorrectement aux questions d'examen <strong>{{amount}}</strong> suivantes :",

    "ResetPassword.PageHeading": "Réinitialiser le mot de passe",

    "resumeConfirmationMessage.withTimer": "Le webinaire est en pause et reprendra dans :",

    "Schedule.LoginToSeeWebinars": "Certains webinaires pourraient ne pas être visibles. Veuillez vous <a>connecter</a> pour un aperçu complet de tous les webinaires.",
    "Schedule.NoPublicWebinars.Text": "Pour le moment, il n'y a pas de webinaires publics disponibles. Veuillez vérifier plus tard, ou vous connecter pour voir la liste complète des webinaires.",
    "Schedule.NoWebinars.Title": "Rien à voir ici pour l'instant",
    "Schedule.NoWebinars.Text": "Les webinaires pour lesquels vous avez indiqué être intéressé apparaîtront ici.",
    "Schedule.PageHeading": "Programme du webinaire",
    "Schedule.ShowMoreOndemand": "Afficher tous les webinaires à la demande",
    "Schedule.ShowMoreUpcoming": "Afficher tous les webinaires à venir",
    "Schedule.Switch.ShowInterested": "Afficher uniquement les webinaires auxquels je me suis inscrit.",
    "Schedule.UpNext": "Prochainement",

    "Search.Button.Clear.AriaLabel": "Effacer la sélection",
    "Search.Placeholder": "Rechercher un webinaire",

    "Security.AllowAnonymousWarning": "Autoriser les spectateurs anonymes signifie que toute personne possédant le lien de votre webinaire peut le visionner, même sans être connectée. Cela contourne donc toutes les mesures de sécurité. Ne partagez le lien de votre webinaire qu'avec des personnes de confiance. Pour renforcer la sécurité, vous pouvez définir un code d'autorisation qui générera un lien spécifique pour les spectateurs anonymes.",
    "Security.AnonymousViewerAuthorizationCodeLabel": "Code d'autorisation du spectateur anonyme",
    "Security.AnonymousViewerLinkLabel": "Lien pour les spectateurs anonymes :",
    "Security.Button.GenerateCode": "Générer du code",
    "Security.Introtext": "Sur cette page, vous pouvez autoriser ou refuser l'accès à ce webinaire à des comptes. Vous pouvez le faire en entrant une ou plusieurs adresses e-mail. Il est également possible d'inclure ou d'exclure des adresses e-mail d'un domaine, en entrant @nomdedomaine (par exemple @onlinewebinar.com).",
    "Security.InfoText.Important": "Important !",
    "Security.InfoText.Item1": "Le refus a priorité sur l'autorisation. Cela signifie que si vous refusez un domaine entier, il est impossible d'autoriser un seul compte avec une adresse e-mail de ce domaine.<br /> L'inverse fonctionnera : vous pouvez autoriser des comptes avec des adresses e-mail d'un domaine particulier. Refuser une adresse e-mail de ce domaine empêchera toujours ce compte de regarder ce webinaire.",
    "Security.InfoText.Item2": "Refuser des comptes les empêchera uniquement de pouvoir regarder votre webinaire. Ils pourront toujours voir la page de détails de votre webinaire.",
    "Security.Filter.Allow": "Filtre d'autorisation",
    "Security.Filter.Disallow": "Filtre de refus",
    "Security.Filter.Button.Save": "Enregistrer votre filtre",
    "Security.FilterResults.Heading": "Résultats du filtre",
    "Security.FilterResults.Label.TestResults": "Tester l'adresse e-mail",
    "Security.FilterResults.Table.Header.Email": "Adresse e-mail",
    "Security.PageHeading": "Sécurité du webinaire",
    "Security.Switch.OneViewerSession": "Autoriser une seule session de visionnage par participant",
    "Security.Switch.RequireVerified": "Exiger des comptes vérifiés",
    "Security.Switch.AllowAnonymous": "Autoriser les visiteurs anonymes",

    "Share.Button.CopyLink": "Copier le lien",
    "Share.CopiedLink": "Lien copié avec succès",
    "Share.InviteBroadcaster.Heading": "Inviter un diffuseur en utilisant un lien",
    "Share.InviteBroadcaster.Text": "Vous pouvez inviter un ou plusieurs diffuseurs à votre webinaire en partageant ce lien :",
    "Share.InviteBroadcaster.WarningText": "Important ! Ne partagez ce lien qu'avec des personnes de confiance.",
    "Share.InviteModerator.Heading": "Inviter un modérateur à l'aide d'un lien",
    "Share.InviteModerator.Text": "Vous pouvez inviter un ou plusieurs modérateurs pour votre webinaire en partageant ce lien :",
    "Share.InviteModerator.WarningText": "Important ! Ne partagez ce lien qu'avec des personnes de confiance.",
    "Share.InviteParticipants.AnonymousEnabled.WarningText": "Important ! Ne partagez ce lien qu’avec des personnes de confiance. L’accès anonyme est activé, ce qui signifie que toute personne disposant du lien vers votre webinaire peut le visionner, même sans être connectée. Cette fonctionnalité contourne donc toutes les mesures de sécurité.",
    "Share.InviteParticipants.Heading": "Inviter des participants à l'aide d'un lien",
    "Share.InviteParticipants.Text": "Vous pouvez inviter d'autres personnes à s'inscrire et à regarder votre webinaire en partageant ce lien :",
    "Share.InviteSpeaker.Heading": "Inviter un intervenant en utilisant un lien",
    "Share.InviteSpeaker.Text": "Vous pouvez inviter un ou plusieurs intervenants à votre webinaire en partageant ce lien :",
    "Share.PageHeading": "Partager votre webinaire",
    "Share.SignUps": "Inscriptions",
    "Share.InviteAnonymous.Heading": "Invitez des spectateurs anonymes via un lien",
    "Share.InviteAnonymous.Text": "Vous pouvez inviter des spectateurs anonymes à votre webinaire en partageant ce lien :",
    "Share.InviteAnonymous.WarningText": "Important ! Ne partagez ce lien qu’avec des personnes de confiance. Autoriser les spectateurs anonymes signifie que toute personne possédant le lien vers votre webinaire pourra le visionner, même sans être connectée. Cela contourne donc toutes les mesures de sécurité.",

    "Speaker.List.Heading": "Intervenants ({{count}})",
    "Speaker.List.Button.Notify": "Notifier {{name}}",
    "Speaker.List.Button.Kick": "Retirer {{name}} du webinaire",
    "Speaker.Status.Offline": "Hors ligne",
    "Speaker.Status.SettingUp": "Configuration",
    "Speaker.Status.AwaitingAdmission": "En attente d'admission",
    "Speaker.Status.Connecting": "Connexion",
    "Speaker.Status.NotReady": "Pas prêt",
    "Speaker.Status.Ready": "Prêt",
    "Speaker.Status.GoingLive": "Passage en direct",
    "Speaker.Status.OnAir": "En direct",
    "Speaker.Status.Error": "Erreur",
    "Speaker.Status.Banned": "Banni",

    "Speaker.WaitingRoom.Heading": "Salle d'attente des intervenants",
    "Speaker.WaitingRoom.Kicked": "Vous avez été retiré du webinaire par le diffuseur.",
    "Speaker.WaitingRoom.Notified": "Le diffuseur souhaite attirer votre attention.",
    "Speaker.WaitingRoom.Status.Live": "Le webinaire est en direct.",
    "Speaker.WaitingRoom.Status.WaitingReady": "Vous êtes prêt — en attente que le diffuseur vous ajoute à l'antenne.",
    "Speaker.WaitingRoom.Status.WaitingNotReady": "Activez « Prêt » lorsque vous souhaitez indiquer au diffuseur que vous êtes prêt.",
    "Speaker.WaitingRoom.ReadyToggle.Label": "Je suis prêt à intervenir",

    "Slide.Button.Current": "Aller à la diapositive actuelle",
    "Slide.Button.First": "Aller à la première diapositive",
    "Slide.Button.Next": "Diapositive suivante",
    "Slide.Button.Previous": "Diapositive précédente",

    "Status.Message.Interrupted": "La diffusion est interrompue. Veuillez patienter.",
    "Status.Message.NotStarted": "La diffusion n'a pas encore commencé. Veuillez patienter.",
    "Status.Message.Paused": "La diffusion est en pause. Veuillez patienter.",

    "TestSuite.Button.RetryTest": "Exécutez à nouveau le test",
    "TestSuite.Button.StartTest": "Démarrer le test",
    "TestSuite.BroadcastConnection.Error": "Une erreur s'est produite lors de la connexion à la vidéo diffusée. Veuillez actualiser la page.",
    "TestSuite.BroadcastConnection.UnstableNetwork": "La connexion réseau est instable. Veuillez vérifier votre connexion internet.",
    "TestSuite.BroadcastConnection.VeryUnstableNetwork": "La connexion réseau est très instable. Veuillez vérifier votre connexion internet.",
    "TestSuite.BroadcastScore.Audio": "Score audio :",
    "TestSuite.BroadcastScore.Video": "Score video :",
    "TestSuite.BroadcastState.Broadcasting": "Diffusion",
    "TestSuite.BroadcastState.Initializing": "Initialisation",
    "TestSuite.BroadcastState.NotBroadcasting": "Ne pas diffuser",
    "TestSuite.Connection.Connected": "Connecté",
    "TestSuite.Connection.Connecting": "Connexion",
    "TestSuite.Connection.Disconnected": "Déconnecté",
    "TestSuite.Connection.Label": "Connexion :",
    "TestSuite.PageHeading": "Préparez-vous pour votre webinaire",
    "TestSuite.PlayerConnection.Error": "Une erreur s'est produite lors de la connexion du lecteur vidéo. Veuillez actualiser la page.",
    "TestSuite.PlayerConnection.Live": "En direct",
    "TestSuite.PlayerConnection.NotLive": "Pas en direct",
    "TestSuite.PlayerState.Buffering": "Mise en mémoire tampon",
    "TestSuite.PlayerState.Paused": "En pause",
    "TestSuite.PlayerState.Playing": "Lecture",
    "TestSuite.Progress.Label": "Essai",
    "TestSuite.State.Label": "Statut :",
    "TestSuite.Text.Disclaimer": "<em>Remarque :</em> le test ne fournit qu'un instantané. <br/>Si vous modifiez votre connexion Internet ou la qualité de votre réseau ultérieurement, exécutez à nouveau le test pour vous assurer que tout fonctionne correctement.",
    "TestSuite.Text.Explanation": "À gauche, vous verrez votre vidéo source et à droite, ce que vos spectateurs verront. Il y aura un léger décalage entre votre vidéo et celle que vos spectateurs verront.",
    "TestSuite.Text.PreTest": "Ce test vous permet de vérifier le bon fonctionnement de votre connexion aux serveurs OnlineWebinar. Nous effectuerons un test d'une minute pour nous assurer que la vidéo et l'audio sont correctement transmis.<br/>Pour ce test, utilisez le même ordinateur et la même caméra que ceux utilisés pendant la diffusion.",
    "TestSuite.Text.TestEnded": "Le test est terminé. Si tout semble bon, vous êtes prêt à commencer votre webinaire !",
    "TestSuite.Text.RetryTest": "Réessayer le test",
    "TestSuite.Transport.Label": "Type de connexion :",
    "TestSuite.Transport.Moq": "Media over QUIC ({{transport}})",
    "TestSuite.Transport.MoqUnknown": "Media over QUIC",
    "TestSuite.Transport.Classic": "Connexion classique (WebRTC)",
    "TestSuite.Transport.MoqFailed": "Media over QUIC n'a pas pu se connecter ; le test continue via la connexion classique.",
    "TestSuite.ApiErrorCode.NotReadyException": "Veuillez réessayer plus tard.",
    "TestSuite.ApiErrorCode.NotReadyException.Body": "Il n'y a actuellement aucun canal de test disponible. Veuillez réessayer plus tard.",
    "Title.ForWebinar": "{{page}} pour {{webinar}}",
    "Title.RegisterForWebinar": "S'inscrire à {{webinar}}",
    "Title.WatchWebinar": "Regarder {{webinar}}",
    "Title.EditWebinar": "Modifier {{webinar}}",
    "Title.Upcoming": "Aperçu des webinaires à venir",
    "Title.OnDemand": "Aperçu des webinaires à la demande",
    "Title.VerifyAccount": "Vérifier votre compte",
    "Title.Unsubscribe": "Se désabonner",
    "Title.NotFound": "Page introuvable",
    "Title.AccountManagerInvite": "Invitation de gestionnaire de compte",
    "Title.BroadcastWebinar": "Diffuser {{webinar}}",
    "Title.Moderator": "Modérateur",
    "Title.SlideController": "Contrôle des diapositives",
    "Title.DeleteWebinar": "Supprimer {{webinar}}",
    "Title.ShareWebinar": "Partager {{webinar}}",
    "Title.Content": "Contenu",
    "Title.Analytics": "Analyse",
    "Title.OrganizedUpcoming": "Webinaires à venir organisés",
    "Title.OrganizedEnded": "Webinaires terminés organisés",

    "Translation.InfoText": "Le fichier de traduction mis à jour doit être soit un fichier de traduction JSON, soit un fichier Excel. Le fichier Excel doit avoir deux colonnes, la première colonne doit contenir la clé et la deuxième colonne doit contenir la traduction. La première ligne doit contenir les en-têtes \"Clé\" et \"Traduction\".",
    "Translation.PageHeading": "Gérer la traduction",
    "Translation.Table.Header.Key": "Clé",
    "Translation.Table.Header.Translation": "Traduction",

    "Validation.Email.Required": "L'adresse e-mail n'a pas été renseignée.",
    "Validation.Email.Invalid": "L'adresse e-mail n'est pas valide. Une adresse valide contient un @ suivi d'un domaine avec un point, sans espaces. Par exemple : nom@exemple.fr",
    "Validation.Email.MaxLength": "L'e-mail peut avoir un maximum de 245 caractères",
    "Validation.CompanyName.MaxLength": "L'entreprise peut avoir un maximum de 100 caractères",
    "Validation.ForgotPasswordCode.Required": "Le code n'a pas été renseigné.",
    "Validation.Password.Required": "Le mot de passe n'a pas été renseigné.",
    "Validation.Password.ComplexityScore0": "Le mot de passe est très faible. Veuillez utiliser un mot de passe plus fort.",
    "Validation.Password.ComplexityScore1": "Le mot de passe est faible. Veuillez utiliser un mot de passe plus fort.",
    "Validation.Password.ComplexityScore2": "Le mot de passe est modéré. Veuillez utiliser un mot de passe plus fort.",
    "Validation.Password.ComplexityScore3": "Le mot de passe est fort",
    "Validation.Password.ComplexityScore4": "Le mot de passe est très fort",
    "Validation.Nickname.Required": "Le pseudo n'a pas été renseigné.",
    "Validation.Nickname.MinLength": "Le pseudo doit avoir au moins 3 caractères",
    "Validation.Nickname.MaxLength": "Le pseudo peut avoir un maximum de 70 caractères",
    "Validation.FirstName.Required": "Le prénom n'a pas été renseigné.",
    "Validation.FirstName.MaxLength": "Le prénom peut avoir un maximum de 35 caractères",
    "Validation.LastName.Required": "Le nom de famille n'a pas été renseigné.",
    "Validation.LastName.MaxLength": "Le nom de famille peut avoir un maximum de 35 caractères",
    "Validation.TermsOfAgreement.Required": "Vous devez accepter les termes et conditions",

    "Video.Initializing": "Nous initialisons l'audio et la vidéo. Veuillez autoriser l'accès à votre caméra et à votre microphone lorsque vous y êtes invité.",

    "Viewer.Message.Button.InterestedOverview": "Webinaires abonnés",
    "Viewer.Message.MultipleSessions": "Il semble que vous regardez ce webinaire dans une autre fenêtre ou un autre onglet de navigateur, ou sur un autre appareil.<br />Vous pouvez actualiser cette page pour continuer à regarder ici.",
    "Viewer.Message.TestWebinarFull": "Ce webinaire test a atteint son maximum de {{maxViewers}} spectateurs.",
    "Viewer.Message.WebinarCancelled": "Le webinaire que vous souhaitez regarder a été annulé.",
    "Viewer.Message.WebinarExpired": "Le webinaire que vous souhaitez regarder n'a pas eu lieu.",
    "Viewer.Message.WebinarPlanned": "Ce webinaire commencera dans",
    "Viewer.Message.WebinarNotStarted": "Le webinaire n'a pas encore commencé, veuillez patienter",
    "Maintenance.Notice.Title": "Maintenance",
    "Maintenance.Gateway.Title": "Maintenance en cours",
    "Maintenance.Gateway.Body": "La plateforme est temporairement indisponible pour maintenance. Cette page reprendra automatiquement dès que la plateforme sera de retour.",
    "Viewer.Message.ConnectionLost": "La connexion au webinaire a été perdue. Veuillez vérifier votre connexion Internet et actualiser la page.",
    "Viewer.Message.ConnectionConnecting": "Connexion au webinaire, veuillez patienter...",

    "WebinarAnalytics.Heading.AudioPackets": "Paquets audio envoyés",
    "WebinarAnalytics.Heading.AudioScore": "Score audio",
    "WebinarAnalytics.Heading.BytesSent": "Octets envoyés",
    "WebinarAnalytics.Heading.PacketDelay": "Délai de transmission des paquets",
    "WebinarAnalytics.Heading.RetransmittedPackets": "Paquets retransmis envoyés",
    "WebinarAnalytics.Heading.VideoPackets": "Paquets vidéo envoyés",
    "WebinarAnalytics.Heading.VideoScore": "Score vidéo",
    "WebinarAnalytics.PageHeading": "Analyse des webinaires",

    "WebinarButton.Status.Cancelled": "Voir les détails",
    "WebinarButton.Status.Ended": "Statistiques",
    "WebinarButton.Status.Expired": "Modifier le webinaire",
    "WebinarButton.Status.Started": "Diffuser",
    "WebinarButton.Status.Planned": "Diffuser",

    "Webinar.Button.Reschedule": "Reprogrammer",
    "Webinar.Data.Attachment": "pièces jointes",
    "Webinar.Data.Exam": "examen",
    "Webinar.Data.Heading": "Statut",
    "Webinar.Data.Status.NotEnabled": "Non",
    "Webinar.Data.Status.Enabled": "Oui",
    "Webinar.Data.Status.NotValid": "Non valide",
    "Webinar.Data.Chapters": "chapitres",
    "Webinar.Data.Interested": "intéressé",
    "Webinar.Data.OndemandViews": "vues à la demande",
    "Webinar.Data.Polls": "sondages",
    "Webinar.Data.Security": "sécurité",
    "Webinar.Data.Slides": "diapositives",
    "Webinar.Data.Survey": "sondage",
    "Webinar.Data.Viewers": "spectateurs",
    "Webinar.DateTime.StartIn": "Commence dans :",
    "Webinar.DateTime.StartNow": "Commencer maintenant",
    "Webinar.Live": "En direct",
    "Webinar.StatusMessage.Cancelled": "Ce webinaire a été <span>annulé</span>.",
    "Webinar.StatusMessage.Expired": "Ce webinaire a <span>expiré</span>.",
    "Webinar.StatusMessage.Timeslot": "Le créneau horaire sélectionné pour ce webinaire n'est pas disponible ! <span>Veuillez reprogrammer votre webinaire !</span>",
    "Webinar.Visibility.Private": "Privé",
    "Webinar.Warning.NotPublished": "Non publié",
    "Webinar.Warning.NotPublished.Body": "Ce webinaire n'a pas encore été publié et n'est pas visible par les spectateurs.",
    "Webinar.Warning.NoBooking": "Créneau horaire non disponible.",
    "Webinar.Warning.NoBooking.Body": "Il n'y a pas de créneau horaire disponible pour ce webinaire. Vous ne pouvez pas diffuser le webinaire.",
    "Webinar.Warning.Dangerzone": "Zone de danger",
    "Webinar.Button.Cancel": "Annuler le webinaire",
    "Webinar.Button.Delete": "Supprimer ce webinaire",
    "Webinar.Delete.Deletecode.Label": "Confirmer le code de suppression",
    "Webinar.Delete.DeleteCode": "Veuillez entrer le code pour confirmer la suppression. Notez que ce code est sensible à la casse.",
    "Webinar.Delete.PageHeading": "Supprimer le webinaire",
    "Webinar.Delete.Warning": "Êtes-vous sûr de vouloir supprimer le webinaire suivant ? C'est permanent et ne peut pas être annulé.",
    "Webinar.Warning.WebinarIsCancelled": "Ce webinaire est annulé.",
    "Webinar.Warning.WebinarIsCancelled.Body": "Ce webinaire est annulé et ne peut pas être regardé mais est toujours visible.",
    "Webinar.CancelWebinar.Title": "Annuler le webinaire",
    "Webinar.CancelWebinar.Description": "Êtes-vous sûr de vouloir annuler ce webinaire ? Cela ne peut pas être annulé.",
    "Webinar.CancelWebinar.Button.Close": "Non",
    "Webinar.CancelWebinar.Button.Cancel": "Oui, annuler le webinaire",
    "Webinar.RescheduleWebinar.Title": "Reprogrammer le webinaire",
    "Webinar.RescheduleWebinar.Description": "Vous êtes responsable d'informer les participants de la nouvelle date et heure de diffusion. Voulez-vous continuer ?",
    "Webinar.Test.Badge": "Webinaire test",
    "Webinar.Test.Switch.Label": "Ceci est un webinaire test",
    "Webinar.Test.Confirm.Title": "Planifier comme webinaire test ?",
    "Webinar.Test.Confirm.Description": "Un webinaire test dure au maximum {{maxDurationMinutes}} minutes, accepte au maximum {{maxViewers}} spectateurs et n'est pas facturé. Il est supprimé automatiquement {{deleteAfterStartHours}} heures après le début prévu, enregistrement compris, et ne peut pas être converti en véritable webinaire par la suite.",
    "Webinar.Test.Confirm.Button.Confirm": "Oui, planifier un webinaire test",
    "Webinar.Test.Confirm.Button.Close": "Non",
    "Webinar.Test.Notice.Title": "Ceci est un webinaire test",
    "Webinar.Test.Notice.Body": "Au maximum {{maxDurationMinutes}} minutes et {{maxViewers}} spectateurs, non facturé.",
    "Webinar.Test.Notice.DeleteOn": "Il est supprimé automatiquement après le {{deleteOn}}, enregistrement compris.",
    "Webinar.Test.DeleteOn": "Supprimé automatiquement après le {{deleteOn}}",
    "Webinar.Test.Countdown.Limit": "Webinaire test : la diffusion s'arrête automatiquement après {{maxDurationMinutes}} minutes",
    "Webinar.Test.Countdown.Ending": "Webinaire test : s'arrête automatiquement dans",
    "Webinar.Schedule.Warning.TestDurationMaximum": "Un webinaire test ne peut pas dépasser {{maxDuration}} minutes",

    "WebinarDetails.Button.NoLongerInterested": "Plus intéressé",
    "WebinarDetails.Button.Interested": "Intéressé",
    "WebinarDetails.Button.UploadBannerImage.AriaLabel": "Télécharger l'image de bannière pour ce webinaire",
    "WebinarDetails.Button.UploadProfileImage.AriaLabel": "Télécharger l'image de profil pour ce webinaire",
    "WebinarDetails.Button.UseDefaultBannerImage.AriaLabel": "Supprimer l'image et utiliser l'image de bannière par défaut",
    "WebinarDetails.Button.UseDefaultProfileImage.AriaLabel": "Supprimer l'image et utiliser l'image de profil par défaut",
    "WebinarDetails.Button.UseDefaultImage": "Utiliser par défaut",
    "WebinarDetails.Button.WatchIn": "Regarder dans {{watchCountdown}}",
    "WebinarDetails.Button.VerifyToWatch": "Vérifier pour regarder",
    "WebinarDetails.By": "par",
    "WebinarDetails.Label.Date": "Date",
    "WebinarDetails.Label.Duration": "Durée",
    "WebinarDetails.Label.Host": "Hôte",
    "WebinarDetails.Label.Time": "Heure",
    "WebinarDetails.Label.Visibility.Private": "Webinaire privé : ce webinaire ne sera visible que pour les personnes ayant reçu une invitation ou un lien de partage.",
    "WebinarDetails.Label.Visibility.Public": "Webinaire public : ce webinaire sera visible dans l'aperçu.",
    "WebinarDetails.Legend.Visibility": "Visibilité du webinaire",
    "WebinarDetails.Section.OnDemand": "À la demande",
    "WebinarDetails.Label.OnDemand.Enabled": "Autoriser les spectateurs à regarder à la demande",
    "WebinarDetails.Info.OnDemandPreparing": "Votre enregistrement est en cours de préparation. Revenez bientôt.",
    "Content.OnDemand.Status.Processing": "En cours de traitement",
    "Content.OnDemand.Status.Available": "Disponible",
    "Content.OnDemand.Status.Failed": "Échec",
    "WebinarDetails.Link.BackToOverview": "Retour aux événements à venir",
    "WebinarDetails.Heading.Attachments": "Pièces jointes",
    "WebinarDetails.Heading.Related": "Écouter ce webinaire en podcast",
    "WebinarDetails.Warning.AccessRestricted": "L'accès à ce webinaire a été restreint",
    "WebinarDetails.Warning.LinkExpired": "Votre lien personnel a expiré.",
    "WebinarDetails.Warning.OnDemandNotAvailable": "Ce webinaire est terminé et n'est actuellement pas disponible à la demande.",

    "WebinarDurationSettings.Figure.ChannelAllocation": "Répartition des canaux",
    "WebinarDurationSettings.Figure.ChannelInUse": "Canal en cours d'utilisation",
    "WebinarDurationSettings.Figure.PlannedDuration": "Durée prévue",
    "WebinarDurationSettings.Figure.PlannedEndTime": "Heure de fin prévue du webinaire",
    "WebinarDurationSettings.Figure.PlannedStartTime": "Heure de début prévue du webinaire",
    "WebinarDurationSettings.Figure.RunOutTime": "Temps d'épuisement",
    "WebinarDurationSettings.InfoText": "<p>Un canal est réservé à la diffusion d'un webinaire. Sa durée dépend de trois facteurs :</p> <ul><li>Le délai avant l'heure de début prévue, auquel le canal est attribué. À partir de ce moment, la diffusion peut commencer ;</li><li>La durée prévue du webinaire ;</li><li>Le délai de prolongation après la durée prévue du webinaire.</li></ul><p></p>",
    "WebinarDurationSettings.PageHeading": "Paramètres de durée du webinaire",
    "WebinarDurationSettings.Text.DurationAfterEnd": "Temps d'arrêt supplémentaire après l'heure de fin prévue :",
    "WebinarDurationSettings.Text.DurationBeforeStart": "Heure à laquelle le canal est attribuée avant l'heure de début prévue :",
    "WebinarDurationSettings.Text.MaxDuration": "La durée maximale prévue d'un webinaire :",
    "WebinarDurationSettings.Text.TotalDuration": "La durée maximale totale d'un webinaire :",

    "webinarProgress.failedToLoadStreamText": "échec du chargement du flux vidéo",

    "Webinar.Schedule.Label.BroadcastDate": "Date de diffusion",
    "Webinar.Schedule.Label.ClientReference": "Référence client",
    "Webinar.Schedule.Label.Description": "Description",
    "Webinar.Schedule.Label.Duration": "Durée",
    "Webinar.Schedule.Label.HostName": "Nom de l'hôte",
    "Webinar.Schedule.Label.Title": "Titre du webinaire",
    "Webinar.Schedule.PageHeading": "Planifier votre webinaire",
    "Webinar.Edit.PageHeading": "Modifier votre webinaire",
    "Webinar.Schedule.Warning.DateFuture": "La date de diffusion doit être dans le futur",
    "Webinar.Schedule.Warning.DateRequired": "La date de diffusion est requise",
    "Webinar.Schedule.Warning.DurationMaximum": "Veuillez sélectionner une durée ne dépassant pas {{maxDuration}}",
    "Webinar.Schedule.Warning.DurationMinimum": "La durée minimale est de {{minDuration}} minutes",
    "Webinar.Schedule.Warning.NameMax": "Le nom ne peut pas dépasser 350 caractères",
    "Webinar.Schedule.Warning.NameMin": "Le nom doit comporter au moins 3 caractères",
    "Webinar.Schedule.Warning.NameRequired": "Le nom est requis",
    "Webinar.Schedule.Warning.Timeslot": "Le créneau horaire demandé n'est pas disponible",
    "Webinar.Schedule.Warning.TitleMax": "Le titre ne peut pas dépasser 350 caractères",
    "Webinar.Schedule.Warning.TitleMin": "Le titre doit comporter au moins 3 caractères",
    "Webinar.Schedule.Warning.TitleRequired": "Le titre est requis",

    "WebinarUpNext.Button.Share": "Partager",
    "WebinarUpNext.Button.StartBroadcast": "Démarrer la diffusion",
    "WebinarUpNext.Button.Test": "Test de connexion",
    "WebinarUpNext.Heading.UpNext": "Prochainement",

    "Javascript.Required": "JavaScript est requis pour utiliser cette application. Veuillez activer JavaScript dans votre navigateur et actualiser la page.",

    "Manage.Link.EmailLists": "Gérer les listes d'e-mails",
    "Manage.Link.Blacklist": "Gérer la liste noire",

    "EmailLists.PageHeading": "Listes d'e-mails",
    "EmailLists.Button.Import": "Importer une nouvelle liste",
    "EmailLists.Button.BackToLists": "Retour aux listes d'e-mails",
    "EmailLists.Button.BackToCampaign": "Retour à la campagne",
    "EmailLists.Heading.YourLists": "Vos listes d'e-mails",
    "EmailLists.Table.Header.Description": "Description",
    "EmailLists.Table.Header.ImportedDate": "Importée le",
    "EmailLists.Table.Header.RecipientCount": "Destinataires",
    "EmailLists.Table.Header.SendCount": "Envois",
    "EmailLists.Table.Header.LastSendAt": "Dernier envoi",
    "EmailLists.Table.Header.Status": "Statut",
    "EmailLists.Status.Importing": "Importation",
    "EmailLists.Status.Active": "Active",
    "EmailLists.Status.Deleted": "Supprimée",
    "EmailLists.Import.PageHeading": "Importer une nouvelle liste d'e-mails",
    "EmailLists.Import.Label.Description": "Description de la liste",
    "EmailLists.Import.Button.Import": "Importer la liste",
    "EmailLists.Import.Error.DescriptionRequired": "Veuillez saisir une description pour cette liste",
    "EmailLists.Detail.ImportedDate": "Importée le",
    "EmailLists.Detail.RecipientCount": "Destinataires",
    "EmailLists.Detail.Status": "Statut",
    "EmailLists.Detail.Button.Send": "Envoyer un e-mail",
    "EmailLists.Detail.Button.Delete": "Supprimer la liste",
    "EmailLists.Detail.SendLog.Heading": "Historique des envois",
    "EmailLists.Detail.SendLog.Empty": "Aucun e-mail n'a encore été envoyé à cette liste.",
    "EmailLists.Detail.Campaigns.Heading": "Campagnes marketing",
    "EmailLists.Detail.Campaigns.Name": "Campagne",
    "EmailLists.Detail.Campaigns.UsedAt": "Envoyée le",
    "EmailLists.Detail.Campaigns.View": "Voir la campagne",
    "EmailLists.Detail.SendLog.TemplateType": "Type",
    "EmailLists.Detail.SendLog.SentAt": "Envoyé le",
    "EmailLists.Detail.SendLog.RecipientCount": "Destinataires",
    "EmailLists.Detail.SendLog.SentCount": "Envoyés",
    "EmailLists.Detail.SendLog.FailedCount": "Échecs",
    "EmailLists.Detail.SendLog.BlacklistedCount": "Sur liste noire",
    "EmailLists.Detail.SendLog.Actions": "Détails",
    "EmailLists.Detail.SendLog.AlreadyInterestedCount": "Déjà intéressé",
    "EmailLists.Detail.SendLog.ViewTemplate": "Voir l'e-mail",
    "EmailLists.Detail.Tab.Members": "Destinataires",
    "EmailLists.Detail.Tab.SendHistory": "Historique des envois",
    "EmailLists.Detail.Description.Label": "Description de la liste",
    "EmailLists.Detail.Description.Edit": "Modifier la description",
    "EmailLists.Detail.Members.Empty": "Cette liste n'a pas encore de destinataires.",
    "EmailLists.Detail.Members.Header.Email": "Adresse e-mail",
    "EmailLists.Detail.Members.Header.Name": "Nom",
    "EmailLists.Detail.Members.Header.Company": "Entreprise",
    "EmailLists.Detail.Members.RemoveLabel": "Retirer {{email}} de la liste",
    "EmailLists.Detail.Members.RemoveTitle": "Retirer le destinataire ?",
    "EmailLists.Detail.Members.RemoveBody": "Voulez-vous vraiment retirer {{email}} de cette liste ?",
    "EmailLists.Detail.Members.RemoveConfirm": "Retirer",
    "EmailLists.Detail.Members.Locked": "Cette liste a déjà été utilisée pour envoyer des e-mails, ses destinataires ne peuvent donc plus être modifiés.",
    "EmailLists.Detail.Append.Heading": "Ajouter des destinataires",
    "EmailLists.Detail.Append.Intro": "Importez un autre fichier pour ajouter des destinataires à cette liste. Les adresses e-mail en double sont automatiquement ignorées.",
    "EmailLists.Detail.Append.Button": "Ajouter à la liste",
    "EmailLists.TemplateType.EmailList": "E-mail général",
    "EmailLists.TemplateType.WebinarEmailList": "E-mail de webinaire",
    "EmailLists.Send.Title": "Envoyer un e-mail à cette liste",
    "EmailLists.Send.TemplateTypeLabel": "Quel e-mail souhaitez-vous envoyer ?",
    "EmailLists.Send.WebinarLabel": "Choisir un webinaire",
    "EmailLists.Send.WebinarPlaceholder": "Sélectionnez un webinaire...",
    "EmailLists.Send.WebinarGroup.Upcoming": "Webinaires à venir",
    "EmailLists.Send.WebinarGroup.Ended": "Webinaires terminés",
    "EmailLists.Send.AlreadySentWarning": "Ce type d'e-mail a déjà été envoyé à cette liste.",
    "EmailLists.Send.AudienceHeading": "Audience",
    "EmailLists.Send.ExcludeInterested": "Exclure les comptes déjà intéressés par ce webinaire",
    "EmailLists.Send.AlreadyInterested": "Déjà intéressé",
    "EmailLists.Send.AlreadyInterestedSummary": "{{count}} destinataires sur {{total}} sont déjà intéressés par ce webinaire",
    "EmailLists.Send.ExcludedSuffix": "ils seront exclus de cet envoi",
    "EmailLists.Send.PublishWebinarFirst": "Publiez le webinaire avant de pouvoir envoyer.",
    "EmailLists.Send.SubjectLabel": "Objet",
    "EmailLists.Send.BodyLabel": "Message",
    "EmailLists.Send.Confirm": "Envoyer",
    "EmailLists.View.Title": "E-mail envoyé",
    "EmailLists.Delete.Title": "Supprimer cette liste d'e-mails ?",
    "EmailLists.Delete.Body.Unused": "Cela supprimera définitivement la liste et tous ses destinataires. Cette action est irréversible.",
    "EmailLists.Delete.Body.Used": "Cette liste a déjà été utilisée pour envoyer des e-mails. Les données personnelles de ses destinataires seront effacées, mais un historique des envois est conservé pour votre audit. Cette action est irréversible.",
    "EmailLists.Delete.Confirm": "Supprimer la liste",

    "Blacklist.PageHeading": "Liste noire",
    "Blacklist.Search.Label": "Rechercher par adresse e-mail",
    "Blacklist.Search.Placeholder": "Rechercher...",
    "Blacklist.Table.Header.Email": "Adresse e-mail",
    "Blacklist.Table.Header.BlacklistedAt": "Ajoutée le",
    "Blacklist.Table.Header.Source": "Source",
    "Blacklist.Source.UnsubscribeLink": "Lien de désabonnement",
    "Blacklist.Source.AdminUi": "Administrateur",
    "Blacklist.Source.ProfileToggle": "Paramètre de profil",
    "Blacklist.Button.Remove": "Retirer {{email}} de la liste noire",
    "Blacklist.Empty": "Aucune adresse e-mail trouvée sur la liste noire.",
    "Blacklist.Remove.Title": "Retirer de la liste noire ?",
    "Blacklist.Remove.Body": "Êtes-vous sûr de vouloir retirer {{email}} de la liste noire ?",
    "Blacklist.Remove.Confirm": "Retirer",

    "Unsubscribe.Error.Title": "Une erreur est survenue",
    "Unsubscribe.Success.Title": "Vous avez été désabonné",
    "Unsubscribe.Success.Body": "Vous ne recevrez plus d'e-mails non sollicités de {{brand}}.",
    "Unsubscribe.Resubscribe.Prompt": "Ce n'était pas votre intention ?",
    "Unsubscribe.Resubscribe.Button": "Se réabonner",
    "Unsubscribe.Resubscribed.Title": "Vous avez été réabonné",
    "Unsubscribe.Resubscribed.Body": "Vous recevrez à nouveau des e-mails de {{brand}}.",

    "EmailPreferences.PageHeading": "Préférences e-mail",
    "EmailPreferences.Description": "Gérez si vous recevez des e-mails non sollicités de cet environnement.",
    "EmailPreferences.Toggle.Label": "Me désabonner des e-mails non sollicités",

    "ChatLinkDomains.PageHeading": "Domaines des liens du chat",
    "ChatLinkDomains.Intro": "Les liens des messages du chat s'ouvrent directement pour les domaines de la liste autorisée ; tout autre lien affiche d'abord un avertissement. Les domaines de la liste bloquée ne peuvent pas être publiés, et les liens vers ceux-ci dans les anciens messages ne sont plus cliquables. Chaque lien reste vérifié contre les logiciels malveillants et l'hameçonnage, y compris ceux de la liste autorisée — la liste autorisée exprime une confiance, aussi pour les liens publiés par le passé. N'autorisez pas les raccourcisseurs d'URL ni les sites avec des redirections ouvertes.",
    "ChatLinkDomains.AllowedDomains.Label": "Liste autorisée",
    "ChatLinkDomains.AllowedDomains.Help": "Un domaine par ligne, par exemple example.com. Les sous-domaines sont inclus.",
    "ChatLinkDomains.BlockedDomains.Label": "Liste bloquée",
    "ChatLinkDomains.BlockedDomains.Help": "Un domaine par ligne. Un sous-domaine bloqué l'emporte sur un domaine parent autorisé.",
    "ChatLinkDomains.Save": "Enregistrer",
    "ChatLinkDomains.Save.Success": "Les listes de domaines ont été enregistrées.",
    "ChatLinkDomains.Save.Error": "Les listes de domaines n'ont pas pu être enregistrées.",
    "Manage.Link.ChatLinkDomains": "Gérer les domaines des liens du chat",
    "Chat.Message.LinkNotAllowed": "Votre message n'a pas pu être envoyé car il contient un lien non autorisé. Modifiez ou supprimez le lien et réessayez.",
    "Chat.Message.TooManyLinks": "Un message peut contenir au maximum 10 liens.",
    "Chat.LinkWarning.Title": "Lien non vérifié",
    "Chat.LinkWarning.Body": "Ce lien mène à un site web que nous n'avons pas vérifié. Voulez-vous continuer vers <strong>{{hostname}}</strong> ? Il s'ouvrira dans un nouvel onglet.",
    "Chat.LinkWarning.Continue": "Continuer",
    "Manage.Link.UsageStatistics": "Voir l’utilisation",
    "UsageStatistics.PageHeading": "Statistiques d’utilisation",
    "UsageStatistics.Range.ThisMonth": "Ce mois-ci",
    "UsageStatistics.Range.LastMonth": "Le mois dernier",
    "UsageStatistics.Range.ThisQuarter": "Ce trimestre",
    "UsageStatistics.Range.ThisYear": "Cette année",
    "UsageStatistics.Today.Heading": "Aujourd’hui jusqu’à présent",
    "UsageStatistics.Provisional": "La journée d’aujourd’hui n’est pas encore figée : ces chiffres sont provisoires et ne sont inclus ni dans les totaux de la période ni dans l’export.",
    "UsageStatistics.DaysMissing": "Aucune donnée n’est encore disponible pour {{count}} jour(s) de cette période.",
    "UsageStatistics.ApproximateOnDemand": "Les dates de publication à la demande antérieures au déploiement sont estimées à partir de la date de diffusion.",
    "UsageStatistics.Export": "Exporter vers Excel",
    "UsageStatistics.StockDelta": "{{change}} sur cette période",
    "UsageStatistics.NoStockBaseline": "Aucune donnée n’est disponible pour le jour précédant cette période ; la variation sur la période ne peut donc pas être affichée. Les niveaux eux-mêmes ne sont pas affectés.",
    "UsageStatistics.Metric.LiveWebinars": "Webinaires en direct",
    "UsageStatistics.Metric.WebinarMinutes": "Minutes de webinaire",
    "UsageStatistics.Metric.LiveViewers": "Participations en direct",
    "UsageStatistics.Metric.LiveWatchMinutes": "Minutes visionnées en direct",
    "UsageStatistics.Metric.OnDemandViewers": "Sessions de visionnage à la demande",
    "UsageStatistics.Metric.OnDemandWatchMinutes": "Minutes visionnées à la demande",
    "UsageStatistics.Metric.OnDemandCatalogue": "Catalogue à la demande",
    "UsageStatistics.Metric.StorageBytes": "Stockage utilisé (octets)",
    "UsageStatistics.Metric.TestWebinars": "Webinaires test",
    "UsageStatistics.Filter.From": "Du",
    "UsageStatistics.Filter.To": "Au",
    "UsageStatistics.Chart.LiveWebinarsPerWeek": "Webinaires en direct par semaine",
    "UsageStatistics.Chart.NoData": "Aucun jour figé avec des données sur cette période pour le moment.",
    "UsageStatistics.Billing.Heading": "Heures de webinaire facturables",
    "UsageStatistics.Billing.BlockSize": "Comptabilisé par blocs de {{size}} spectateurs",
    "UsageStatistics.Billing.Allowance": "Convenu : {{hours}} heures par mois",
    "UsageStatistics.Billing.MonthsOver": "{{count}} des 12 derniers mois ont dépassé les heures convenues",
    "UsageStatistics.Billing.Webinar": "Webinaire",
    "UsageStatistics.Billing.PeakViewers": "Pic de spectateurs",
    "UsageStatistics.Billing.Blocks": "Blocs",
    "UsageStatistics.Billing.BillableMinutes": "Minutes facturables"
}
